
// import StorageIcon from "@mui/icons-material/Storage"; // for “Core”
import React, { useState, useEffect, useContext, useRef, useMemo, useCallback } from "react";
import {
  Typography,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Tooltip,
  CircularProgress,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  TextField,
  InputAdornment,
  IconButton,
  Chip,
  Stack,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Skeleton,
  Alert,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Tabs,
  Tab, 
  Pagination ,
} from "@mui/material";
import { useParams, useHistory, useLocation } from "react-router-dom";
import LinearProgress from "@mui/material/LinearProgress";
import InstanceLeftSidebar from "../../InstanceLeftSidebar";
import { AuthContext } from "../../../../helpers/AuthContext";
import { Formik, Field, Form, ErrorMessage } from "formik";
import axios from "axios";
import { toast } from "react-toastify";
import * as Yup from "yup";
import { useTheme } from "@mui/material/styles";

// Icons
import CloudIcon from "@mui/icons-material/Cloud";
import BuildIcon from "@mui/icons-material/Build";
import Badge from "@mui/material/Badge";
import InventoryIcon from "@mui/icons-material/Inventory";
import PublicIcon from "@mui/icons-material/Public";
import FlagIcon from "@mui/icons-material/Flag";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import AssistantIcon from "@mui/icons-material/Assistant";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import StorageIcon from "@mui/icons-material/Storage";
import ImageIcon from "@mui/icons-material/Image";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import ClearIcon from "@mui/icons-material/Clear";
import FolderOffIcon from "@mui/icons-material/FolderOff";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import StorefrontIcon from "@mui/icons-material/Storefront";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TwitterIcon from "@mui/icons-material/Twitter";
import XIcon from "@mui/icons-material/X";
import YouTubeIcon from "@mui/icons-material/YouTube";
import CloseIcon from "@mui/icons-material/Close";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import ImageNotSupportedIcon from "@mui/icons-material/ImageNotSupported";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";

import { getAllClientAccounts } from "../../../../services/shipping";
import ThirdPartyShippingAccount from "../../../../components/Shipping/ThirdPartyShippingAccount";
import QboVendorLinkDialog from "../../../../components/QboVendorLinkDialog";
import SupplierApiIntegrationTab from "./SupplierApiIntegrationTab";
import { resolveCanonicalSupplierCoreId } from "./supplierIdentityHelpers";
import ProductPopup from "../products/ProductPopup";
import { ROLE_OPTIONS } from "../../../../utils/roleOptions";
import { UITableShell, UITableToolbar } from "../../../../components/ui";

import Snackbar from "@mui/material/Snackbar";

import "./style.css";
import { canManagePreferredSuppliers, formatAsiAddress, isSupplierAdministrator, normalizeAsiContacts, normalizeAsiOverview } from "./asiSupplierDetail";

const SupplierSourceTabs = [
  { key: "connected", label: "Preferred Suppliers",   icon: AssistantIcon, tooltip: "Suppliers that are preferred by Elite Promo Marketing" },
  { key: "core",      label: "Custom Suppliers",        icon: StorageIcon,   tooltip: "Access custom suppliers not available on ASI" },
  { key: "all",       label: "All ASI Suppliers",     icon: FingerprintIcon, tooltip: "All suppliers from ASI Central" },
];

// Custom component to display supplier logo or fallback to a placeholder icon
const SupplierLogoCell = ({ supplierName }) => {
  const [hasError, setHasError] = useState(false);
  const logoUrl = `/supplier-reference/${supplierName}/logo.png`;
  

  if (hasError) {
    return <div className="fallback-logo"><ImageIcon /></div>;
  }

  return (
    <img
      src={logoUrl}
      alt={`${supplierName} logo`}
      onError={() => setHasError(true)}
      className="supplier-logo-img custom-logo"
      style={{ width: 50, height: 50, objectFit: "contain" }}
    />
  );
};



const ALL_SUPPLIER_COLUMNS = [
  { id: "s_no",    label: "#",             sortable: false, minWidth: 55,  align: "center", visible: true,  locked: false },
  { id: "logo",    label: "Logo",          sortable: false, minWidth: 110, align: "left",   visible: true,  locked: false },
  { id: "Name",    label: "Supplier Name", sortable: true,  minWidth: 200, align: "left",   visible: true,  locked: false },
  { id: "activity", label: "Activity", sortable: false, minWidth: 120, align: "left", visible: true, locked: false },
  { id: "AsiNumber", label: "ASI #",       sortable: false, minWidth: 130, align: "left",   visible: true,  locked: false },
  { id: "phone",   label: "Phone",         sortable: false, minWidth: 150, align: "left",   visible: true,  locked: false },
  { id: "address", label: "Address",       sortable: false, minWidth: 280, align: "left",   visible: true,  locked: false },
  { id: "action",  label: "Actions",       sortable: false, minWidth: 100, align: "center", visible: true,  locked: true  },
];

 
const SUPPLIER_EXPORT_COLS = Object.freeze([
  { id: "Name",      label: "Supplier Name" },
  { id: "AsiNumber", label: "ASI #"         },
  { id: "phone",     label: "Phone"         },
  { id: "address",   label: "Address"       },
]);

 
const getSupplierExportVal = (row, id) => {
  switch (id) {
    case "Name":      return row.Name      || "";
    case "AsiNumber": return row.AsiNumber || "";
    case "phone":     return row.phoneLabel || "";
    case "address":   return row.addressLabel || "";
    default:          return "";
  }
};

const formatDiagnosticValue = (value) => {
  if (value == null) return "null";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") return String(value);
  try {
    return JSON.stringify(value, null, 2);
  } catch (error) {
    return String(value);
  }
};

const SOCIAL_LINK_META = {
  Facebook: { icon: FacebookIcon, color: "#1877f2" },
  Twitter: { icon: TwitterIcon, color: "#0f1419" },
  X: { icon: XIcon, color: "#0f1419" },
  LinkedIn: { icon: LinkedInIcon, color: "#0a66c2" },
  YouTube: { icon: YouTubeIcon, color: "#ff0000" },
  Instagram: { icon: InstagramIcon, color: "#c13584" },
};

const SupplierSocialLinks = ({ links = [] }) => (
  <Box className="supplier-social-links">
    {links.map((link) => {
      const meta = SOCIAL_LINK_META[link.label] || { icon: OpenInNewIcon, color: "#475569" };
      const SocialIcon = meta.icon;
      return (
        <Button
          key={`${link.label}-${link.url}`}
          component="a"
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`Open ${link.label} in a new tab`}
          startIcon={<SocialIcon fontSize="small" />}
          size="small"
          variant="outlined"
          sx={{
            width: "fit-content",
            flex: "0 0 auto",
            color: meta.color,
            borderColor: meta.color,
            textTransform: "none",
            "&:hover": { bgcolor: meta.color, borderColor: meta.color, color: "common.white" },
          }}
        >
          {link.label}
        </Button>
      );
    })}
  </Box>
);


const InstanceSuppliers = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [updates, setUpdates] = useState([]);
  const [newStatus, setNewStatus] = useState("");
  const [tab, setTab]             = useState(() => { const q = new URLSearchParams(window.location.search).get("supplierTab"); return ["connected", "custom", "core", "all"].includes(q) ? q : "connected"; });
  // ASI directory filter: CA selects Canada; ALL retains the combined global + Canadian search.
  const [market, setMarket] = useState(() => new URLSearchParams(window.location.search).get("market")?.toUpperCase() === "CA" ? "CANALL" : "GLOBAL");
  const [suppliers, setSuppliers] = useState([]); // API fetched suppliers (for both tabs)
  const [newSupplierName, setNewSupplierName] = useState("");
  const [showPopup, setShowPopup] = useState(false); // For New Supplier popup
  const [activeTab, setActiveTab] = useState("connectedSuppliers");
  const [rpp, /* no setter */] = useState(99);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const autoOpenSupplierId = queryParams.get("openSupplier");
  const supplierSearchTerm = queryParams.get("supplierQuery") || "";

  const [showViewPopup, setShowViewPopup] = useState(false); // For View Supplier popup
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  // Separate state for the search input vs. search query.
  const [searchInput, setSearchInput] = useState(supplierSearchTerm);
  const [searchQuery, setSearchQuery] = useState(supplierSearchTerm);
  const [total, setTotal]         = useState(0);
  const [canadianMatches, setCanadianMatches] = useState([]);
  const [asiSearchPartial, setAsiSearchPartial] = useState(false);
  const { authState } = useContext(AuthContext);
  let history = useHistory();
  const [page, setPage] = useState(1);
  const [rows, setRows] = useState([]);
  let {instanceUniqueId} = useParams();
  const [supplierDirectorySort, setSupplierDirectorySort] = useState(() => {
    try {
      const saved = localStorage.getItem(`supplierDirectorySort:${instanceUniqueId}`);
      return ["name-asc", "name-desc", "recent"].includes(saved) ? saved : "name-asc";
    } catch {
      return "name-asc";
    }
  });

  useEffect(() => {
    try {
      const saved = localStorage.getItem(`supplierDirectorySort:${instanceUniqueId}`);
      setSupplierDirectorySort(["name-asc", "name-desc", "recent"].includes(saved) ? saved : "name-asc");
    } catch {
      setSupplierDirectorySort("name-asc");
    }
  }, [instanceUniqueId]);




    const theme = useTheme();
  const C = {
    paperBg:       theme.palette.background.paper,
    subtleBg:      theme.palette.action.hover,
    border:        theme.palette.divider,
    textPri:       theme.palette.text.primary,
    textSec:       theme.palette.text.secondary,
    textMuted:     theme.palette.text.disabled,
    white:         theme.palette.common.white,
    headerBg:      theme.eliteCore?.tokens?.color?.neutral?.[800] ?? "#1e293b",
    headerBgHover: theme.eliteCore?.tokens?.color?.neutral?.[700] ?? "#334155",
    headerText:    theme.eliteCore?.tokens?.color?.neutral?.[50]  ?? "#f8fafc",
    headerTextMuted: theme.eliteCore?.tokens?.color?.neutral?.[400] ?? "#94a3b8",
  };

  const [density, setDensity] = useState("comfortable");
  const densitySettings = {
    compact:     { py: 0.75, fontSize: "0.8125rem" },
    comfortable: { py: 1.5,  fontSize: "0.875rem"  },
    spacious:    { py: 2.25, fontSize: "0.9375rem" },
  };
  const currentDensity = densitySettings[density];

  const [visibleColumns, setVisibleColumns] = useState(
    () => new Set(ALL_SUPPLIER_COLUMNS.filter((c) => c.visible !== false).map((c) => c.id))
  );
  const [sortBy,  setSortBy]  = useState("");
  const [sortDir, setSortDir] = useState("asc");

  const [exportAnchorEl,    setExportAnchorEl]    = useState(null);
  const [columnMenuAnchor,  setColumnMenuAnchor]  = useState(null);
  const [densityMenuAnchor, setDensityMenuAnchor] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  const showSnackbar = (message, severity = "success") =>
    setSnackbar({ open: true, message, severity });

  const toggleColVisibility = (colId) =>
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      next.has(colId) ? next.delete(colId) : next.add(colId);
      return next;
    });

  const handleSort = (colId) => {
    if (sortBy === colId) {
      if (sortDir === "asc") setSortDir("desc");
      else { setSortBy(""); setSortDir("asc"); }
    } else {
      setSortBy(colId);
      setSortDir("asc");
    }
  };

 
  const sortedSuppliers = useMemo(() => {
    if (!sortBy) return suppliers;
    return [...suppliers].sort((a, b) => {
      const aVal = String(a[sortBy] ?? "");
      const bVal = String(b[sortBy] ?? "");
      return sortDir === "asc" ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
    });
  }, [suppliers, sortBy, sortDir]);

  // Active filter detection
  // const hasActiveFilters = !!(searchInput);

  const hasActiveFilters = !!searchInput || (tab === "all" && market === "CANALL");

  const handleClearFilters = () => {
    setSearchInput("");
    setSearchQuery("");
    if (tab === "all") setMarket("GLOBAL");
    setPage(1);
  };

 
  const visibleColsForTab = useMemo(() => {
    return ALL_SUPPLIER_COLUMNS.filter((col) => {
      if (!visibleColumns.has(col.id)) return false;
      if (col.id === "activity" && tab !== "connected" && tab !== "core") return false;
      if (col.id === "AsiNumber" && (tab === "connected" || tab === "core")) return false;
      return true;
    });
  }, [visibleColumns, tab]);
 
  const exportCSV = () => {
    const rows = [SUPPLIER_EXPORT_COLS.map((c) => c.label).join(",")];
    sortedSuppliers.forEach((s) => {
      rows.push(
        SUPPLIER_EXPORT_COLS.map(
          (c) => `"${String(getSupplierExportVal(s, c.id)).replace(/"/g, '""')}"`
        ).join(",")
      );
    });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([rows.join("\n")], { type: "text/csv;charset=utf-8;" }));
    a.download = `suppliers_${new Date().toISOString().split("T")[0]}.csv`;
    a.click();
    showSnackbar("CSV exported successfully");
  };

  const exportExcel = () => {
    const rows = [SUPPLIER_EXPORT_COLS.map((c) => c.label).join("\t")];
    sortedSuppliers.forEach((s) => {
      rows.push(SUPPLIER_EXPORT_COLS.map((c) => getSupplierExportVal(s, c.id)).join("\t"));
    });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([rows.join("\n")], { type: "application/vnd.ms-excel" }));
    a.download = `suppliers_${new Date().toISOString().split("T")[0]}.xls`;
    a.click();
    showSnackbar("Excel exported successfully");
  };

  const exportPDF = () => {
    const doc = new jsPDF({ orientation: "landscape" });
    doc.setFontSize(14);
    doc.text("Suppliers Report", 14, 15);
    doc.setFontSize(9);
    doc.text(`Generated: ${new Date().toLocaleString("en-IN")}   Total: ${total}`, 14, 22);
    autoTable(doc, {
      head: [SUPPLIER_EXPORT_COLS.map((c) => c.label)],
      body: sortedSuppliers.map((s) => SUPPLIER_EXPORT_COLS.map((c) => getSupplierExportVal(s, c.id))),
      startY: 28,
      styles: { fontSize: 7, cellPadding: 1.5, overflow: "ellipsize" },
      headStyles: { fillColor: [30, 41, 59], textColor: [255, 255, 255], fontStyle: "bold" },
      alternateRowStyles: { fillColor: [248, 250, 252] },
    });
    doc.save(`suppliers_${new Date().toISOString().split("T")[0]}.pdf`);
    showSnackbar("PDF exported successfully");
  };

  const normalizedRole = authState.role.replace(/_/g, '-');
  const currentRoleLabel =
    ROLE_OPTIONS.find(opt => opt.value === normalizedRole)?.label
    || authState.role;

  // Define columns for supplier data.
  // The "Logo" column now combines the supplier logo and connected icon.
    const columns = [
      {
        field: "logo",
        headerName: "Logo",
        width: 140,
        renderCell: (params) => {
          const { Name, connected, References } = params.row;
          const supplierName = Name || "default";
    
          // normalize the incoming JSON field
          const refs = Array.isArray(References) ? References : [];
    
          // detect each source
          const hasAsiLive    = refs.some(r => r.source === "asi-live");
          const hasCustomCore = refs.some(r => r.source === "custom-core");
    
          return (
            <Box display="flex" alignItems="center" gap={1}>
              {/* your existing logo + connected check */}
              <SupplierLogoCell supplierName={supplierName} />
              {connected && (
                <AssistantIcon sx={{ color: "green" }} />
              )}
    
              {/* ASI-Live badge */}
              {hasAsiLive && (
                <Tooltip title="ASI Live">
                  <CloudIcon sx={{ color: "info.main" }} />
                </Tooltip>
              )}
    
              {/* Custom-Core badge */}
              {hasCustomCore && (
                <Tooltip title="Custom Core">
                  <BuildIcon sx={{ color: "warning.main" }} />
                </Tooltip>
              )}
            </Box>
          );
        },
      },
    { field: "id", headerName: "ID", width: 10 },
    { field: "Name", headerName: "Supplier Name", width: 200 },
    { field: "AsiNumber", headerName: "ASI number", width: 250 },
    { field: "phoneLabel", headerName: "Phone", width: 150 },
    { field: "addressLabel", headerName: "Address", width: 300 },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => (
        <div className="cellAction">
          <div className="viewButton" onClick={() => viewSupplierDetails(params.row)}>
            View
          </div>
        </div>
      ),
    },
  ];

  const columnsToShow = React.useMemo(() => {
    // hide ASI number on connected & core tabs
    if (tab === "connected" || tab === "core") {
      return columns.filter(col => col.field !== "AsiNumber");
    }
    // on “all” show everything
    return columns;
  }, [tab]);

  // Header search may link to a supplier outside the current directory page.
  useEffect(() => {
    if (!autoOpenSupplierId || !instanceUniqueId) return;
    let canceled = false;
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/supplier-search-detail/${encodeURIComponent(autoOpenSupplierId)}`, {
      params: { instanceUniqueId },
      headers: { accessToken: localStorage.getItem("accessToken") },
    }).then(({ data }) => {
      if (canceled || !data?.supplier) return;
      setSelectedSupplier(data.supplier);
      setShowViewPopup(true);
    }).catch((error) => {
      if (!canceled) console.error("Unable to open searched supplier", error);
    });
    return () => { canceled = true; };
  }, [autoOpenSupplierId, instanceUniqueId]);

  // Always fetch supplier data from API on mount.
    useEffect(() => {
        fetchSuppliers(searchQuery, page);
    }, [tab, page, searchQuery, market, supplierDirectorySort]);

    const fetchSuppliers = async (query, pageToLoad) => {
      setLoading(true);
      try {

        const { data } = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/get-suppliers`,
          {
            params: {
              instanceUniqueId,
              q: query,
              ...(tab === "all" ? { market: market === "CANALL" ? "CA" : "ALL" } : {}),
              page: pageToLoad,
              rpp,
              sort: tab === "connected" || tab === "core" ? supplierDirectorySort : "DFLT",
              tab,
              accessContext: "supplier-directory",
            },
            headers: { accessToken: localStorage.getItem("accessToken") },
          }
        );
    
        const normalizeRows = rows => rows.map(raw => {
          // if this is a “connected” row, the real supplier lives under raw.Supplier
          const src = raw.Supplier || raw;
        
          // grab both JSON and any legacy string fields
          const addr = src.Address || {};
          const address1 = addr.Street1  || addr.street1 || src.Street1 || src.street1 || '';
          const city     = addr.City     || addr.city    || src.City    || src.city    || '';
          const state    = addr.State    || addr.state   || '';
          const postal   = addr.Zip      || addr.zip     || src.Zip     || src.zip     || '';
          const country  = addr.Country  || addr.country || '';
        
          // flatten into one human line
          const addressLabel = address1
            ? `${address1}${city ? ', ' + city : ''}${state ? ' ' + state : ''}${postal ? ' ' + postal : ''}${country ? ', ' + country: ''}`
            : 'n/a';
        
          // Phone can be a JSON object or plain string
          const ph = src.Phone;
          const phoneLabel =
            (ph && typeof ph === 'object' && (ph.Work || ph.TollFree))     ? (ph.Work || ph.TollFree)
          : (typeof ph === 'string'                                           ? ph
          : (src.phone                                                      ? src.phone
          : 'n/a'));
        
          return {
            ...src,
        
            // stash raw objects for your popup
            _Address: addr,
            _Phone:   ph,
        
            // DataGrid fields
            id:           src.Id,
            Name:         src.Name,
            AsiNumber:    src.AsiNumber,
            addressLabel,
            phoneLabel,
        
            connected: Boolean(raw.connected ?? src.connected),
            archived: Boolean(src.archived),
          };
        });
        
        setSuppliers(normalizeRows(data.rows || []));
        setCanadianMatches(normalizeRows(data.canadianMatches || []));
        setAsiSearchPartial(Boolean(data.partial));
        setTotal(data.total);

        

      } catch (error) {
        console.error("Error fetching suppliers:", error);
      } finally {
        setLoading(false);
      }
    };
    

  // Open a popup with supplier details.
  const viewSupplierDetails = (supplier) => {
    setSelectedSupplier(supplier);
    setShowViewPopup(true);
  };

  const handlePostStatus = () => {
    if (newStatus.trim() !== "") {
      const newUpdate = {
        id: updates.length + 1,
        title: "New Status Update",
        content: newStatus,
        timestamp: new Date().toLocaleString(),
        role: "Employee",
        comment: "No comments yet.",
        commentAuthor: "You",
        tag: "General",
        avatar: "https://via.placeholder.com/40",
      };
      setUpdates([newUpdate, ...updates]);
      setNewStatus("");
    }
  };

  const handleNewSupplierSubmit = (e) => {
    e.preventDefault();
    // Add the new supplier to the API-based list.
    const newSupplier = {
      id: Date.now(),
      Name: newSupplierName,
      AsiNumber: "", // Adjust as needed for new supplier
      Phone: "Unknown",
      Address: "Unknown",
      connected: false,
      website: "",
      contacts: [],
    };
    setSuppliers((prevSuppliers) => [...prevSuppliers, newSupplier]);
    setShowPopup(false);
    console.log("New supplier created, navigate to edit form.");
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Clear search input when switching tabs if desired.
    setSearchInput("");
    setSearchQuery("");
  };

  const handleTabClick = (newTab) => {
    setTab(newTab);
    setSearchInput("");
    setSearchQuery("");
    setPage(1);
    if (newTab !== "all") setMarket("GLOBAL");
  };

  // When user clicks the Search button, update searchQuery and re-fetch API data for All Suppliers.
  const handleSearch = () => {
    setSearchQuery(searchInput);
    setPage(1);
  };


  



//             {loading ? (
//               <div className="retrieving-all-supplier-loading MuiDataGrid-virtualScrollerContent css-1kwdphh-MuiDataGrid-virtualScrollerContent">
//                 <CircularProgress /> <span>Retrieving all suppliers...</span>
//               </div>
//             ) : (
//               <DataTable
//                 columns={columnsToShow}
//                 rows={suppliers}
//                 loading={loading}
//                 page={page}               // 1‑based page
//                 pageSize={rpp}       // e.g. 50
//                 rowCount={total}          // total rows from the server
//                 onPageChange={setPage}    // DataTable will call this with new page
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );


  return (
    <div className="instance-dashboard">
      <InstanceLeftSidebar />
      <div className="rightSide">
        <Box
          sx={{
            p: { xs: 1, md: 2 },
            display: "flex",
            flexDirection: "column",
            height: "calc(100vh - 60px)",
            overflow: "hidden",
            width: "100%"
          }}
        >
          <UITableShell
            customLayout
            paperSx={{
              flex: 1,
              borderRadius: "10px",
              border: "1px solid",
              borderColor: "divider",
              borderTop: "3px solid",
              borderTopColor: "primary.main",
              minHeight: 0,
              boxShadow: "0 1px 3px 0 rgba(0,0,0,0.07), 0 1px 2px -1px rgba(0,0,0,0.07)",
            }}
          >
             
            <UITableToolbar sx={{ backgroundColor: C.paperBg }}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                gap={1.5}
              >
                
                <Stack direction="row" alignItems="center" spacing={1.5} flexWrap="wrap" useFlexGap>
                  <Typography variant="h6" fontWeight={700} sx={{ color: C.textPri, lineHeight: 1 }}>
                    Suppliers
                  </Typography>

                  <Chip
                    label={`${total} total`}
                    size="small"
                    sx={{
                      backgroundColor: "var(--ec-status-neutral-bg)",
                      color: "var(--ec-status-neutral-text)",
                      border: "1px solid var(--ec-status-neutral-border)",
                      fontWeight: 600,
                      fontSize: "0.72rem",
                      height: 22,
                    }}
                  />

                  <Divider orientation="vertical" flexItem sx={{ height: 20, alignSelf: "center" }} />

                  {/* Tab chips */}
                  <Stack direction="row" spacing={0.5}>
                    {SupplierSourceTabs.map(({ key, label, icon: Icon, tooltip }) => (
                      <Tooltip key={key} title={tooltip} placement="bottom">
                        <Chip
                          label={
                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                              <Icon sx={{ fontSize: 14 }} />
                              {label}
                            </Box>
                          }
                          size="small"
                          onClick={() => handleTabClick(key)}
                          sx={{
                            cursor: "pointer",
                            fontWeight: 600,
                            fontSize: "0.72rem",
                            height: 26,
                            backgroundColor: tab === key
                              ? "var(--ec-color-primary)"
                              : "var(--ec-status-neutral-bg)",
                            color: tab === key
                              ? "var(--ec-color-surface)"
                              : "var(--ec-status-neutral-text)",
                            border: tab === key
                              ? "1px solid transparent"
                              : "1px solid var(--ec-status-neutral-border)",
                            transition: "all 0.15s ease",
                            "& .MuiChip-label": { px: "10px" },
                            "&:hover": {
                              backgroundColor: tab === key
                                ? "var(--ec-color-primary-dark)"
                                : "var(--ec-color-surface-muted)",
                            },
                          }}
                        />
                      </Tooltip>
                    ))}
                  </Stack>

                </Stack>

 
                <Stack direction="row" spacing={0.5} alignItems="center">

                  {/* Export */}
                  <Tooltip title="Export data">
                    <IconButton
                      size="small"
                      onClick={(e) => setExportAnchorEl(e.currentTarget)}
                      disabled={sortedSuppliers.length === 0}
                      sx={{ color: "text.secondary" }}
                    >
                      <DownloadIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={exportAnchorEl}
                    open={Boolean(exportAnchorEl)}
                    onClose={() => setExportAnchorEl(null)}
                    slotProps={{ paper: { sx: { minWidth: 190, borderRadius: 2 } } }}
                  >
                    <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: "block", color: "text.disabled" }}>
                      Export as
                    </Typography>
                    <Divider sx={{ mb: 0.5 }} />
                    <MenuItem onClick={() => { exportCSV(); setExportAnchorEl(null); }} sx={{ py: 0.75 }}>
                      <ListItemIcon><FileDownloadIcon fontSize="small" /></ListItemIcon>
                      <ListItemText>CSV</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={() => { exportExcel(); setExportAnchorEl(null); }} sx={{ py: 0.75 }}>
                      <ListItemIcon><TableChartIcon fontSize="small" /></ListItemIcon>
                      <ListItemText>Excel</ListItemText>
                    </MenuItem>
                    <MenuItem onClick={() => { exportPDF(); setExportAnchorEl(null); }} sx={{ py: 0.75 }}>
                      <ListItemIcon><PictureAsPdfIcon fontSize="small" /></ListItemIcon>
                      <ListItemText>PDF</ListItemText>
                    </MenuItem>
                  </Menu>

                  {/* Show / Hide columns */}
                  <Tooltip title="Show / hide columns">
                    <IconButton
                      size="small"
                      onClick={(e) => setColumnMenuAnchor(e.currentTarget)}
                      sx={{ color: "text.secondary" }}
                    >
                      <ViewColumnIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={columnMenuAnchor}
                    open={Boolean(columnMenuAnchor)}
                    onClose={() => setColumnMenuAnchor(null)}
                    slotProps={{ paper: { sx: { minWidth: 210, borderRadius: 2 } } }}
                  >
                    <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: "block", color: "text.disabled" }}>
                      Columns
                    </Typography>
                    <Divider sx={{ mb: 0.5 }} />
                    {ALL_SUPPLIER_COLUMNS.filter((c) => !c.locked && (c.id !== "activity" || tab === "connected" || tab === "core")).map((col) => (
                      <MenuItem key={col.id} onClick={() => toggleColVisibility(col.id)} sx={{ py: 0.4 }}>
                        <Checkbox
                          size="small"
                          checked={visibleColumns.has(col.id)}
                          sx={{ p: 0.5, mr: 0.5, color: "primary.main", "&.Mui-checked": { color: "primary.main" } }}
                        />
                        <ListItemText primaryTypographyProps={{ fontSize: "0.875rem" }}>
                          {col.label}
                        </ListItemText>
                      </MenuItem>
                    ))}
                  </Menu>

                  {/* Row density */}
                  <Tooltip title="Row density">
                    <IconButton
                      size="small"
                      onClick={(e) => setDensityMenuAnchor(e.currentTarget)}
                      sx={{ color: "text.secondary" }}
                    >
                      <SettingsIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={densityMenuAnchor}
                    open={Boolean(densityMenuAnchor)}
                    onClose={() => setDensityMenuAnchor(null)}
                    slotProps={{ paper: { sx: { minWidth: 180, borderRadius: 2 } } }}
                  >
                    <Typography variant="overline" sx={{ px: 2, pt: 1.25, pb: 0.5, display: "block", color: "text.disabled" }}>
                      Row density
                    </Typography>
                    {["compact", "comfortable", "spacious"].map((d) => (
                      <MenuItem key={d} onClick={() => { setDensity(d); setDensityMenuAnchor(null); }} sx={{ py: 0.75, textTransform: "capitalize" }}>
                        <Checkbox
                          size="small"
                          checked={density === d}
                          sx={{ p: 0.5, mr: 0.5, color: "primary.main", "&.Mui-checked": { color: "primary.main" } }}
                        />
                        <ListItemText primaryTypographyProps={{ fontSize: "0.875rem", textTransform: "capitalize" }}>
                          {d}
                        </ListItemText>
                      </MenuItem>
                    ))}
                  </Menu>

                  {/* Refresh */}
                  <Tooltip title="Refresh list">
                    <IconButton
                      size="small"
                      onClick={() => {
                        fetchSuppliers(searchQuery, page);
                        showSnackbar("Data refreshed", "success");
                      }}
                      sx={{ color: "text.secondary" }}
                    >
                      <RefreshIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>

                  <Divider orientation="vertical" flexItem sx={{ mx: 0.5, height: 24, alignSelf: "center" }} />

                  {/* Primary action */}
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => setShowPopup(true)}
                    sx={{ fontWeight: 700, textTransform: "none", height: 34, px: 2, whiteSpace: "nowrap" }}
                  >
                    Request Supplier
                  </Button>
                </Stack>
              </Stack>

              {/* divider between title row and filter row */}
              <Divider sx={{ mt: 1.75, mb: 0 }} />

        
              <Stack direction="row" spacing={1.5} mt={1.75} flexWrap="wrap" useFlexGap alignItems="center">
                <TextField
                  placeholder="Search suppliers by name…"
                  size="small"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); handleSearch(); } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon sx={{ fontSize: 16, color: C.textMuted }} />
                      </InputAdornment>
                    ),
                    endAdornment: searchInput ? (
                      <InputAdornment position="end">
                        <IconButton size="small" onClick={() => setSearchInput("")} edge="end">
                          <ClearIcon sx={{ fontSize: 14 }} />
                        </IconButton>
                      </InputAdornment>
                    ) : null,
                  }}
                  sx={{
                    flex: 2,
                    minWidth: 280,
                    "& .MuiOutlinedInput-root": { backgroundColor: "var(--ec-input-bg)" },
                  }}
                />

                {/* ASI market filter pills - kept in the filters row */}
                  {tab === "all" && (
                    <>
                      <Stack direction="row" spacing={0.5}>
                        <Tooltip title="Show Canadian results">
                          <Chip
                            label={
                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <img
                                  src="https://flagcdn.com/ca.svg"
                                  alt="CA"
                                  style={{ width: 16, height: 11, objectFit: "cover", borderRadius: 2 }}
                                />
                                CA
                              </Box>
                            }
                            size="small"
                            onClick={() => setMarket("CANALL")}
                            sx={{
                              cursor: "pointer",
                              fontWeight: 700,
                              fontSize: "0.72rem",
                              height: 26,
                              backgroundColor: market === "CANALL"
                                ? "var(--ec-color-primary)"
                                : "var(--ec-status-neutral-bg)",
                              color: market === "CANALL"
                                ? "var(--ec-color-surface)"
                                : "var(--ec-status-neutral-text)",
                              border: market === "CANALL"
                                ? "1px solid transparent"
                                : "1px solid var(--ec-status-neutral-border)",
                              "& .MuiChip-label": { px: "10px" },
                            }}
                          />
                        </Tooltip>
                        <Tooltip title="Show all global results">
                          <Chip
                            label={
                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                <CloudIcon sx={{ fontSize: 13 }} />
                                ALL
                              </Box>
                            }
                            size="small"
                            onClick={() => setMarket("GLOBAL")}
                            sx={{
                              cursor: "pointer",
                              fontWeight: 700,
                              fontSize: "0.72rem",
                              height: 26,
                              backgroundColor: market === "GLOBAL"
                                ? "var(--ec-color-primary)"
                                : "var(--ec-status-neutral-bg)",
                              color: market === "GLOBAL"
                                ? "var(--ec-color-surface)"
                                : "var(--ec-status-neutral-text)",
                              border: market === "GLOBAL"
                                ? "1px solid transparent"
                                : "1px solid var(--ec-status-neutral-border)",
                              "& .MuiChip-label": { px: "10px" },
                            }}
                          />
                        </Tooltip>
                      </Stack>
                    </>
                  )}

                {(tab === "connected" || tab === "core") && (
                  <FormControl size="small" sx={{ minWidth: 185, flex: "1 1 185px", maxWidth: 230 }}>
                    <InputLabel id="supplier-directory-sort-label">Sort by</InputLabel>
                    <Select
                      labelId="supplier-directory-sort-label"
                      label="Sort by"
                      value={supplierDirectorySort}
                      onChange={(event) => {
                        const next = event.target.value;
                        setSupplierDirectorySort(next);
                        setPage(1);
                        try {
                          localStorage.setItem(`supplierDirectorySort:${instanceUniqueId}`, next);
                        } catch {
                          // Sorting works even if browser storage is disabled.
                        }
                      }}
                      sx={{ backgroundColor: "var(--ec-input-bg)", height: 40 }}
                    >
                      <MenuItem value="recent">Recently updated</MenuItem>
                      <MenuItem value="name-asc">Name (A–Z)</MenuItem>
                      <MenuItem value="name-desc">Name (Z–A)</MenuItem>
                    </Select>
                  </FormControl>
                )}

                <Button
                  variant="contained"
                  size="small"
                  startIcon={<SearchIcon sx={{ fontSize: 15 }} />}
                  onClick={handleSearch}
                  sx={{ height: 40, textTransform: "none", fontWeight: 600, px: 2.5, boxShadow: "none", "&:hover": { boxShadow: "none" } }}
                >
                  Search
                </Button>

                {hasActiveFilters && (
                  <Tooltip title="Clear all filters">
                    <Button
                      variant="text"
                      size="small"
                      startIcon={<ClearIcon sx={{ fontSize: 14 }} />}
                      onClick={handleClearFilters}
                      sx={{
                        height: 40,
                        textTransform: "none",
                        fontWeight: 600,
                        color: "text.secondary",
                        px: 1.5,
                        "&:hover": { color: "error.main", backgroundColor: "var(--ec-status-error-bg)" },
                      }}
                    >
                      Clear
                    </Button>
                  </Tooltip>
                )}
              </Stack>
 
              {hasActiveFilters && (
                <Stack direction="row" spacing={0.75} mt={1.25} flexWrap="wrap" useFlexGap alignItems="center">
                  <Typography variant="caption" sx={{ color: C.textMuted, fontWeight: 600, mr: 0.25 }}>
                    Active filters:
                  </Typography>
                  {searchInput && (
                    <Chip
                      label={`Search: "${searchInput}"`}
                      size="small"
                      onDelete={() => { setSearchInput(""); setSearchQuery(""); setPage(1); }}
                      sx={{
                        backgroundColor: "var(--ec-status-info-bg)",
                        color: "var(--ec-status-info-text)",
                        border: "1px solid var(--ec-status-info-border)",
                        fontWeight: 600,
                        fontSize: "0.72rem",
                      }}
                    />
                  )}
                  {tab === "all" && market === "CANALL" && (
                    <Chip
                      label="Market: Canada"
                      size="small"
                      onDelete={() => setMarket("GLOBAL")}
                      sx={{
                        backgroundColor: "var(--ec-status-neutral-bg)",
                        color: "var(--ec-status-neutral-text)",
                        border: "1px solid var(--ec-status-neutral-border)",
                        fontWeight: 600,
                        fontSize: "0.72rem",
                      }}
                    />
                  )}
                  <Chip
                    label="Clear all"
                    size="small"
                    onClick={handleClearFilters}
                    sx={{
                      backgroundColor: "var(--ec-status-error-bg)",
                      color: "var(--ec-status-error-text)",
                      border: "1px solid var(--ec-status-error-border)",
                      fontWeight: 700,
                      fontSize: "0.72rem",
                      cursor: "pointer",
                    }}
                  />
                </Stack>
              )}
            </UITableToolbar>
 
            {tab === "all" && !!searchQuery?.trim() && canadianMatches.length > 0 && (
              <Box sx={{ px: 2, py: 1.25, borderBottom: "1px solid", borderColor: "divider" }}>
                <Typography variant="body2" fontWeight={700}>
                  Additional Canadian ASI matches
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Found automatically alongside the global results. These suggestions do not change directory paging.
                </Typography>
                <Stack direction="row" flexWrap="wrap" gap={0.75} sx={{ mt: 1, maxHeight: 104, overflow: "auto" }}>
                  {canadianMatches.map(supplier => (
                    <Button key={String(supplier.Id)} size="small" variant="outlined"
                      onClick={() => viewSupplierDetails(supplier)}
                      sx={{ textTransform: "none", maxWidth: 270 }}>
                      {supplier.Name}{supplier.AsiNumber ? " · ASI " + supplier.AsiNumber : ""}
                    </Button>
                  ))}
                </Stack>
              </Box>
            )}
            {tab === "all" && asiSearchPartial && (
              <Alert severity="warning" sx={{ borderRadius: 0 }}>
                Some ASI results are temporarily unavailable; the listed suppliers are partial results.
              </Alert>
            )}

            <TableContainer
              sx={{
                flex: 1,
                overflow: "auto",
                minHeight: 0,
                borderRadius: "0 !important",
                "&::-webkit-scrollbar": { width: 6, height: 6 },
                "&::-webkit-scrollbar-thumb": { backgroundColor: "var(--ec-color-border-strong)", borderRadius: 99 },
                "&::-webkit-scrollbar-track": { backgroundColor: "transparent" },
              }}
            >
              <Table stickyHeader size="small" sx={{ minWidth: 800, width: "100%" }}>

             
                <TableHead>
                  <TableRow>
                    {visibleColsForTab.map((col) => (
                      <TableCell
                        key={col.id}
                        align={col.align}
                        onClick={() => col.sortable && handleSort(col.id)}
                        sx={{
                          minWidth: col.minWidth,
                          px: 2,
                          py: 1.25,
                          backgroundColor: "var(--ec-table-head-bg-strong) !important",
                          color: sortBy === col.id
                            ? "var(--ec-table-head-text-inverse)"
                            : "var(--ec-table-head-text-muted)",
                          fontWeight: 700,
                          fontSize: "0.72rem",
                          letterSpacing: "0.06em",
                          textTransform: "uppercase",
                          borderBottom: "none",
                          cursor: col.sortable ? "pointer" : "default",
                          userSelect: "none",
                          whiteSpace: "nowrap",
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                          transition: "all 0.15s",
                          "&:hover": col.sortable
                            ? { backgroundColor: "var(--ec-table-head-bg-hover) !important", color: "var(--ec-table-head-text-inverse)" }
                            : {},
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, justifyContent: col.align === "center" ? "center" : "flex-start" }}>
                          {col.label}
                          {col.sortable && (
                            <Box sx={{ display: "inline-flex", ml: 0.25, opacity: sortBy === col.id ? 1 : 0.4 }}>
                              {sortBy === col.id ? (
                                sortDir === "asc"
                                  ? <ArrowUpwardIcon sx={{ fontSize: 12 }} />
                                  : <ArrowDownwardIcon sx={{ fontSize: 12 }} />
                              ) : (
                                <UnfoldMoreIcon sx={{ fontSize: 13 }} />
                              )}
                            </Box>
                          )}
                        </Box>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

          
                <TableBody
                  sx={{
                    "& .MuiTableCell-root": { borderBottom: `1px solid ${C.border}` },
                    "& .MuiTableRow-root:last-child .MuiTableCell-root": { borderBottom: "none" },
                  }}
                >
                  {/* Skeleton loading */}
                  {loading && [...Array(8)].map((_, i) => (
                    <TableRow key={i}>
                      {visibleColsForTab.map((col) => (
                        <TableCell key={col.id} sx={{ px: 2, py: currentDensity.py }}>
                          <Skeleton
                            variant="rectangular"
                            height={col.id === "logo" ? 40 : 20}
                            sx={{ borderRadius: 1, opacity: 1 - i * 0.09 }}
                          />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}

                  {/* Empty state */}
                  {!loading && sortedSuppliers.length === 0 && (
                    <TableRow>
                      <TableCell
                        colSpan={visibleColsForTab.length}
                        align="center"
                        sx={{ py: 8, borderBottom: "none", background: "transparent" }}
                      >
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                          <Box sx={{
                            width: 64, height: 64, borderRadius: "50%",
                            backgroundColor: "var(--ec-color-surface-muted)",
                            display: "flex", alignItems: "center", justifyContent: "center",
                          }}>
                            <FolderOffIcon sx={{ fontSize: 32, color: "var(--ec-color-text-muted)" }} />
                          </Box>
                          <Box sx={{ textAlign: "center" }}>
                            <Typography variant="h6" fontWeight={600} color="text.secondary" gutterBottom>
                              No suppliers found
                            </Typography>
                            <Typography variant="body2" color="text.disabled" sx={{ maxWidth: 340 }}>
                              {hasActiveFilters
                                ? "No suppliers match your current search."
                                : "No suppliers available for this tab."}
                            </Typography>
                          </Box>
                          <Stack direction="row" spacing={1.5} mt={0.5}>
                            {hasActiveFilters && (
                              <Button
                                variant="outlined"
                                size="small"
                                startIcon={<ClearIcon />}
                                onClick={handleClearFilters}
                                sx={{ textTransform: "none", fontWeight: 600 }}
                              >
                                Clear Filters
                              </Button>
                            )}
                            <Button
                              variant="contained"
                              color="primary"
                              size="small"
                              startIcon={<AddIcon />}
                              onClick={() => setShowPopup(true)}
                              sx={{ textTransform: "none", fontWeight: 700 }}
                            >
                              Request Supplier
                            </Button>
                          </Stack>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}

                  {/* Data rows */}
                  {!loading && sortedSuppliers.map((row, index) => (
                    <TableRow
                      key={row.id || index}
                      hover
                      sx={{
                        cursor: "default",
                        backgroundColor: C.paperBg,
                        transition: "background-color 0.1s",
                        "&:hover": { backgroundColor: C.subtleBg },
                      }}
                    >
                      {visibleColsForTab.map((col) => {
                        let cellContent;

                        if (col.id === "s_no") {
                          cellContent = (page - 1) * rpp + index + 1;

                        } else if (col.id === "logo") {
                          const refs = Array.isArray(row.References) ? row.References : [];
                          const hasAsiLive    = refs.some((r) => r.source === "asi-live");
                          const hasCustomCore = refs.some((r) => r.source === "custom-core");
                          cellContent = (
                            <Box display="flex" alignItems="center" gap={1}>
                              <SupplierLogoCell supplierName={row.Name || "default"} />
                              {row.connected && (
                                <Tooltip title="Preferred Supplier">
                                  <AssistantIcon sx={{ fontSize: 18, color: "success.main" }} />
                                </Tooltip>
                              )}
                              {hasAsiLive && (
                                <Tooltip title="ASI Live">
                                  <CloudIcon sx={{ fontSize: 18, color: "info.main" }} />
                                </Tooltip>
                              )}
                              {hasCustomCore && (
                                <Tooltip title="Custom Core">
                                  <BuildIcon sx={{ fontSize: 18, color: "warning.main" }} />
                                </Tooltip>
                              )}
                            </Box>
                          );

                        } else if (col.id === "Name") {
                          cellContent = (
                            <Typography variant="body2" fontWeight={600} sx={{ color: C.textPri }}>
                              {row.Name || "—"}
                            </Typography>
                          );

                        } else if (col.id === "activity") {
                          const lastUpdated = new Date(row.updatedAt || row.createdAt).getTime();
                          const elapsed = Date.now() - lastUpdated;
                          if (!Number.isFinite(lastUpdated) || !Number.isFinite(elapsed) || elapsed < 0) {
                            cellContent = <Typography variant="body2" color="text.secondary">—</Typography>;
                          } else {
                            const seconds = Math.floor(elapsed / 1000);
                            const minutes = Math.floor(seconds / 60);
                            const hours = Math.floor(minutes / 60);
                            const recent = hours < 24;
                            const label = recent
                              ? seconds < 60 ? `${seconds}s ago` : minutes < 60 ? `${minutes}m ago` : `${hours}h ago`
                              : `${Math.floor(hours / 24)}d ago`;
                            cellContent = (
                              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                                {recent && <WhatshotIcon color="error" fontSize="small" />}
                                <Typography variant="body2" color={recent ? "error" : "text.secondary"}>{label}</Typography>
                              </Box>
                            );
                          }

                        } else if (col.id === "AsiNumber") {
                          cellContent = (
                            <Typography
                              variant="body2"
                              sx={{ fontFamily: "monospace", color: "primary.main", fontWeight: 700, fontSize: "0.82rem" }}
                            >
                              {row.AsiNumber || "—"}
                            </Typography>
                          );

                        } else if (col.id === "phone") {
                          cellContent = (
                            <Typography variant="body2" sx={{ color: C.textSec }}>
                              {row.phoneLabel || "—"}
                            </Typography>
                          );

                        } else if (col.id === "address") {
                          cellContent = (
                            <Tooltip title={row.addressLabel || ""} placement="top">
                              <Typography
                                variant="body2"
                                sx={{
                                  color: C.textSec,
                                  maxWidth: 280,
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {row.addressLabel || "—"}
                              </Typography>
                            </Tooltip>
                          );

                        } else if (col.id === "action") {
                          cellContent = (
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<VisibilityIcon sx={{ fontSize: "0.85rem !important" }} />}
                              onClick={(e) => { e.stopPropagation(); viewSupplierDetails(row); }}
                              sx={{
                                fontSize: "0.72rem",
                                height: 28,
                                borderRadius: "8px",
                                textTransform: "none",
                                fontWeight: 600,
                                minWidth: 70,
                              }}
                            >
                              View
                            </Button>
                          );
                        } else {
                          cellContent = row[col.id] ?? "—";
                        }

                        return (
                          <TableCell
                            key={col.id}
                            align={col.align}
                            sx={{
                              px: 2,
                              py: currentDensity.py,
                              fontSize: currentDensity.fontSize,
                              color: C.textPri,
                              verticalAlign: "middle",
                            }}
                            {...(col.id === "action" ? { onClick: (e) => e.stopPropagation() } : {})}
                          >
                            {cellContent}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
 
            <Box
              sx={{
                px: 2,
                py: 0,
                backgroundColor: C.paperBg,
                borderTop: `1px solid ${C.border}`,
                flexShrink: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                minHeight: 52,
              }}
            >
           
              <Typography variant="body2" sx={{ color: "var(--ec-color-text-muted)", fontSize: "0.8125rem", pl: 1 }}>
                {total > 0
                  ? `Showing ${(page - 1) * rpp + 1}–${Math.min(page * rpp, total)} of ${total} supplier${total !== 1 ? "s" : ""}`
                  : loading ? "" : "No results"}
              </Typography>

           
              <TablePagination
                component="div"
                count={total}
                page={page - 1}
                onPageChange={(_, newPage) => setPage(newPage + 1)}
                rowsPerPage={rpp}
                rowsPerPageOptions={[rpp]}
                sx={{
                  "& .MuiTablePagination-toolbar": { minHeight: 52, px: 0 },
                  "& .MuiTablePagination-displayedRows": { fontSize: "0.8125rem", color: C.textMuted, m: 0 },
                  "& .MuiTablePagination-actions": { ml: 1 },
                  "& .MuiIconButton-root": { borderRadius: 1.5, width: 30, height: 30 },
                  "& .MuiTablePagination-selectLabel": { display: "none" },
                  "& .MuiInputBase-root": { display: "none" },
                }}
              />
            </Box>

          </UITableShell>
        </Box>
 
        {showPopup && (
          <PopupNewSupplier
            setShowPopup={setShowPopup}
            onSupplierCreated={(supplier) => setSuppliers((prev) => [...prev, supplier])}
          />
        )}
        {showViewPopup && selectedSupplier && (
          <PopupViewSupplier
            selectedSupplier={selectedSupplier}
            setShowViewPopup={setShowViewPopup}
            market={market}
            supplierTab={tab}
            onPreferredChanged={(supplierId, connected) => {
              setSelectedSupplier((prev) => prev ? { ...prev, connected } : prev);
              setSuppliers((prev) => prev.map((supplier) =>
                String(supplier.id || supplier.Id) === String(supplierId)
                  ? { ...supplier, connected }
                  : supplier
              ));
            }}
            onSupplierArchived={(archivedSupplier) => {
              setSelectedSupplier(archivedSupplier);
              setSuppliers((prev) =>
                prev.map((supplier) =>
                  String(supplier.id) === String(archivedSupplier.Id || archivedSupplier.id)
                    ? { ...supplier, ...archivedSupplier, archived: true }
                    : supplier
                )
              );
            }}
          />
        )}


        <Snackbar
          open={snackbar.open}
          autoHideDuration={3000}
          onClose={() => setSnackbar(s => ({ ...s, open: false }))}
          message={snackbar.message}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        />


      </div>
    </div>
  );

};

const PopupNewSupplier = ({ setShowPopup, onSupplierCreated }) => {
  const { instanceUniqueId } = useParams();
  const { authState } = useContext(AuthContext);

  const isAdmin = isSupplierAdministrator(authState?.role);
  const [autoApprove, setAutoApprove] = useState(false);

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    fax: "",
    website: "",
    addressStreet: "",
    addressCity: "",
    addressState: "",
    addressPostal: "",
    addressCountry: "",
  };

  const validationSchema = Yup.object({
    name:           Yup.string().required("Supplier Name is required"),
    email:          Yup.string().email("Invalid email"),
    phone:          Yup.string(),
    fax:            Yup.string(),
    website:        Yup.string().url("Must be a valid URL"),
    addressStreet:  Yup.string(),
    addressCity:    Yup.string(),
    addressState:   Yup.string(),
    addressPostal:  Yup.string(),
    addressCountry: Yup.string(),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    const payload = {
      instanceUniqueId,
      InstanceUniqueIds: [instanceUniqueId],
      IsCustomProduct:   true,
      Name:              values.name,
      Email:             values.email || null,
      Phone:             values.phone ? { Work: values.phone } : null,
      Fax:               values.fax || null,
      Websites:          values.website ? [values.website] : [],
      Address: {
        Street1: values.addressStreet || null,
        City:    values.addressCity    || null,
        State:   values.addressState   || null,
        Zip:     values.addressPostal  || null,
        Country: values.addressCountry || null,
      },
      References: [],
      ListDate:   new Date().toISOString(),
      // key bit: only admins see/toggle autoApprove; everyone else => in-review
      Status:     isAdmin && autoApprove ? "approved" : "in-review",
    };
    const token = localStorage.getItem("accessToken");

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/create-supplier`,
        payload,
        { headers: { Authorization: `Bearer ${token}`, accessToken: token } }
      );

      // optional: onSupplierCreated?.(res.data.supplier);
      resetForm();
      const msg =
        isAdmin && autoApprove
          ? "Supplier created & approved"
          : "Supplier request submitted for approval";
      toast.success(msg);
      setShowPopup(false);

      setTimeout(() => window.location.reload(), 800);
    } catch (err) {
      console.error("Failed to create custom supplier:", err);
      alert("Error creating supplier. See console for details.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open
      onClose={() => setShowPopup(false)}
      maxWidth="sm"
      fullWidth
      className="create-order-dialog customer-order-dialog"
    >
      <DialogTitle className="create-order-dialog-title">
        Request a Supplier
      </DialogTitle>

      <DialogContent className="create-order-dialog-content">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="create-order-form">
              <Box mb={2}>
                <Field
                  as={TextField}
                  name="name"
                  label="Supplier Name"
                  placeholder="Acme Promotional"
                  className="create-order-input"
                  fullWidth
                  helperText={<ErrorMessage name="name" />}
                />
              </Box>

              <Box mb={2}>
                <Field
                  as={TextField}
                  name="email"
                  label="Email"
                  placeholder="contact@acme.com"
                  className="create-order-input"
                  fullWidth
                  helperText={<ErrorMessage name="email" />}
                />
              </Box>

              <Box mb={2} display="flex" gap={2}>
                <Field
                  as={TextField}
                  name="phone"
                  label="Phone"
                  placeholder="(555) 123-4567"
                  className="create-order-input"
                  fullWidth
                />
                <Field
                  as={TextField}
                  name="fax"
                  label="Fax"
                  placeholder="(555) 987-6543"
                  className="create-order-input"
                  fullWidth
                />
              </Box>

              <Box mb={2}>
                <Field
                  as={TextField}
                  name="website"
                  label="Website"
                  placeholder="https://acme.com"
                  className="create-order-input"
                  fullWidth
                  helperText={<ErrorMessage name="website" />}
                />
              </Box>

              <Box mb={2}>
                <Field
                  as={TextField}
                  name="addressStreet"
                  label="Street"
                  placeholder="123 Main St."
                  className="create-order-input"
                  fullWidth
                />
              </Box>

              <Box mb={2} display="flex" gap={2}>
                <Field
                  as={TextField}
                  name="addressCity"
                  label="City"
                  placeholder="Calmar"
                  className="create-order-input"
                  fullWidth
                />
                <Field
                  as={TextField}
                  name="addressState"
                  label="State"
                  placeholder="AB"
                  className="create-order-input"
                  fullWidth
                />
              </Box>

              <Box mb={2} display="flex" gap={2}>
                <Field
                  as={TextField}
                  name="addressPostal"
                  label="Postal"
                  placeholder="T0C 0V0"
                  className="create-order-input"
                  fullWidth
                />
                <Field
                  as={TextField}
                  name="addressCountry"
                  label="Country"
                  placeholder="Canada"
                  className="create-order-input"
                  fullWidth
                />
              </Box>

              {/* Admin-only fast-track checkbox */}
              {isAdmin && (
                <Box mb={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={autoApprove}
                        onChange={(e) => setAutoApprove(e.target.checked)}
                      />
                    }
                    label="Approve immediately (skip operations review - admin only)"
                  />
                </Box>
              )}

              <DialogActions className="create-customer-dialog-actions">
                <Button onClick={() => setShowPopup(false)} color="secondary">
                  Cancel
                </Button>
                <Button type="submit" color="primary" disabled={isSubmitting}>
                  Submit Request
                </Button>
              </DialogActions>
            </Form>
          )}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};



const PopupViewSupplier = ({ selectedSupplier, setShowViewPopup, market, supplierTab, onSupplierArchived, onPreferredChanged }) => {

  let {instanceUniqueId} = useParams();
  const theme = useTheme();
  const supplierCoreId = resolveCanonicalSupplierCoreId(selectedSupplier);

  // which tab is active?
  const [popupTab, setPopupTab] = useState("overview");
  const [shippingAccounts, setShippingAccounts] = useState([]);
  const [shippingAccountsLoading, setShippingAccountsLoading] = useState(false);
  const [shippingAccountModalOpen, setShippingAccountModalOpen] = useState(false);

  const [bannerError, setBannerError] = useState(false);
  const [progress, setProgress] = useState(null);

  const startProgressStream = (asiNumber) => {

    const eventSource = new EventSource(
      `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/suppliers/${asiNumber}/import-progress`
    );
  
    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      setProgress(data);
  
      // When the job is done
      if (data.done) {
        setIsImporting(false);    // <— Done HERE, not in finally
        eventSource.close();
      }
    };
  
    eventSource.onerror = () => {
      console.warn("SSE connection error");
    };
  };
  

  const supplierName = selectedSupplier
    ? selectedSupplier.Name || selectedSupplier.name
    : "default";
  const bannerUrl = `/supplier-reference/${supplierName}/banner.jpg`;
  const [showLogo, setShowLogo] = useState(true);
  const { authState } = useContext(AuthContext);
  const [qboDialogOpen, setQboDialogOpen] = useState(false);
  const [supplierDetails, setSupplierDetails] = useState(selectedSupplier);
  const [companyName, setCompanyName] = useState("");
  useEffect(() => {
    let active = true;
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`, {
      headers: { accessToken: localStorage.getItem("accessToken") },
    }).then(({ data }) => {
      if (active) setCompanyName(String(data?.instanceName || "").trim());
    }).catch(() => {
      if (active) setCompanyName("");
    });
    return () => { active = false; };
  }, [instanceUniqueId]);

  const [supplierClassification, setSupplierClassification] = useState("standard");
  const [supplierEditMode, setSupplierEditMode] = useState(false);
  const [supplierSaving, setSupplierSaving] = useState(false);
  const [supplierDraft, setSupplierDraft] = useState({});
  useEffect(() => {
    if (!selectedSupplier?.Id && !selectedSupplier?.id) return;
    let mounted = true;
    setSupplierEditMode(false);
    setSupplierClassification("standard");
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${resolveCanonicalSupplierCoreId(selectedSupplier)}/classification`, {
      params: { instanceUniqueId },
      headers: { accessToken: localStorage.getItem("accessToken") },
    }).then(({ data }) => {
      if (mounted) setSupplierClassification(data?.supplierType || "standard");
    }).catch(() => { if (mounted) setSupplierClassification("standard"); });
    return () => { mounted = false; };
  }, [selectedSupplier?.Id, selectedSupplier?.id, instanceUniqueId]);
  const beginSupplierEdit = () => {
    const source = supplierDetails || selectedSupplier;
    setSupplierDraft({
      Name: source?.Name || "",
      Email: source?.Email || "",
      phone: source?.Phone?.Work || "",
      website: source?.Websites?.[0] || "",
      supplierType: supplierClassification,
    });
    setSupplierEditMode(true);
  };
  const saveSupplierDetails = async () => {
    const notifyError = (message) => toast.error(message, { autoClose: 5000 });
    if (!supplierCoreId) {
      notifyError("Unable to identify this supplier. Close and reopen the supplier before saving.");
      return;
    }
    if (!supplierDraft.Name?.trim()) {
      notifyError("Supplier name is required.");
      return;
    }
    const email = String(supplierDraft.Email || "").trim();
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      notifyError("Enter a valid supplier email address.");
      return;
    }
    if (!["standard", "freight", "service"].includes(supplierDraft.supplierType)) {
      notifyError("Select a valid supplier type.");
      return;
    }
    setSupplierSaving(true);
    try {
      const { data } = await axios.put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/custom-details`,
        { ...supplierDraft, instanceUniqueId },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      if (!data?.success || !data?.supplier) {
        throw new Error("The supplier update could not be confirmed. Please try again.");
      }
      setSupplierDetails(data.supplier);
      setSupplierClassification(data.supplier.supplierType || supplierDraft.supplierType);
      setSupplierEditMode(false);
      toast.success("Supplier details saved successfully.", { autoClose: 3500 });
    } catch (error) {
      const apiMessage = error?.response?.data?.error || error?.response?.data?.message;
      notifyError(apiMessage || error?.message || "Unable to save supplier details. Please try again.");
    } finally {
      setSupplierSaving(false);
    }
  };

  const [disconnectingQbo, setDisconnectingQbo] = useState(false);
  const [contactDialogOpen, setContactDialogOpen] = useState(false);
  const [mergeDialogOpen, setMergeDialogOpen] = useState(false);
  const [mergeSurvivorId, setMergeSurvivorId] = useState("");
  const [mergeSupplierOptions, setMergeSupplierOptions] = useState([]);
  const [mergeSupplierQuery, setMergeSupplierQuery] = useState("");
  const [mergeSupplierSearching, setMergeSupplierSearching] = useState(false);
  const mergeSupplierSearchVersion = useRef(0);
  useEffect(() => {
    if (!mergeDialogOpen || !supplierCoreId || !instanceUniqueId) return;
    const sequence = ++mergeSupplierSearchVersion.current;
    const controller = new AbortController();
    const timeout = setTimeout(async () => {
      setMergeSupplierSearching(true);
      setMergeWarning("");
      try {
        const { data } = await axios.get(process.env.REACT_APP_NODEJS_SERVER_URL + "/suppliers/merge/candidates", {
          params: { instanceUniqueId, sourceSupplierId: supplierCoreId, q: mergeSupplierQuery },
          headers: { accessToken: localStorage.getItem("accessToken") },
          signal: controller.signal,
        });
        if (sequence === mergeSupplierSearchVersion.current) {
          setMergeSupplierOptions(Array.isArray(data?.rows) ? data.rows : []);
        }
      } catch (error) {
        if (sequence === mergeSupplierSearchVersion.current && !axios.isCancel(error)) {
          setMergeSupplierOptions([]);
          setMergeWarning(error?.response?.data?.error || "We couldn't load suppliers. Please try again.");
        }
      } finally {
        if (sequence === mergeSupplierSearchVersion.current) setMergeSupplierSearching(false);
      }
    }, mergeSupplierQuery.trim() ? 250 : 0);
    return () => { clearTimeout(timeout); controller.abort(); };
  }, [mergeDialogOpen, mergeSupplierQuery, supplierCoreId, instanceUniqueId]);
  const [mergeWarning, setMergeWarning] = useState("");
  const [mergePreview, setMergePreview] = useState(null);
  const [mergeLoading, setMergeLoading] = useState(false);
  const [mergeCopySelected, setMergeCopySelected] = useState(false);
  const [mergeSelectedIds, setMergeSelectedIds] = useState([]);
  const [mergeAcknowledged, setMergeAcknowledged] = useState(false);
  const [mergeConfirmed, setMergeConfirmed] = useState(false);
  const [mergeSearch, setMergeSearch] = useState("");
  const [mergeDirty, setMergeDirty] = useState(true);
  const mergeOperationId = useRef(null);
  const resetMergePreview = () => {
    setMergeAcknowledged(false);
    setMergeConfirmed(false); setMergeDirty(true); mergeOperationId.current = null;
  };
  const requestMergePreview = async (ids, shouldCopy) => {
    setMergeLoading(true); setMergeWarning(""); setMergeDirty(true);
    setMergeAcknowledged(false); setMergeConfirmed(false);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/merge/preview`,
        { instanceUniqueId, survivorSupplierId: mergeSurvivorId,
          selectedProductIds: ids, copySelected: shouldCopy },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      setMergePreview(response.data);
      setMergeDirty(false);
      setMergeAcknowledged(false);
      setMergeConfirmed(false);
      mergeOperationId.current = null;
    } catch (error) {
      setMergePreview(null);
      setMergeWarning(error?.response?.data?.error || "We couldn\'t load the comparison. Please try again.");
    } finally { setMergeLoading(false); }
  };
  const confirmMerge = async () => {
    if (!mergePreview || mergeDirty || !mergeAcknowledged || !mergeConfirmed || mergeLoading) return;
    setMergeLoading(true); setMergeWarning("");
    if (!mergeOperationId.current) mergeOperationId.current =
      window.crypto?.randomUUID?.() || `00000000-0000-4000-8000-${Date.now().toString(16).padStart(12, "0").slice(-12)}`;
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/merge/commit`,
        { instanceUniqueId, survivorSupplierId: mergeSurvivorId,
          selectedProductIds: mergeSelectedIds, copySelected: mergeCopySelected,
          previewHash: mergePreview.previewHash, operationId: mergeOperationId.current,
          confirmPreferences: true, confirm: true },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      const archivedSupplier = { ...(supplierDetails || selectedSupplier), archived: true };
      setSupplierDetails(archivedSupplier);
      onSupplierArchived?.(archivedSupplier);
      setMergeDialogOpen(false);
      toast.success(`Merge complete: ${response.data.archivedProducts} archived, ${response.data.copiedProducts} copied.`);
    } catch (error) {
      setMergeWarning(error?.response?.data?.error || "Merge failed. Review the latest state.");
    } finally { setMergeLoading(false); }
  };

  const [contactSaving, setContactSaving] = useState(false);
  const [productPopupOpen, setProductPopupOpen] = useState(false);
  const [popupProductId, setPopupProductId] = useState(null);
  const [asiSupplierDetail, setAsiSupplierDetail] = useState(null);
  const [asiDiagnosticLoading, setAsiDiagnosticLoading] = useState(false);
  const [asiDiagnosticError, setAsiDiagnosticError] = useState("");
  const asiRequestSequence = useRef(0);

  const importedDateLabel = (value) => {
    const raw = value?.createdAt || value?.CreatedAt || value?.importedAt || value?.ImportedAt;
    if (!raw || Number.isNaN(new Date(raw).getTime())) return null;
    return new Date(raw).toLocaleDateString();
  };
  const roleNormalized = String(authState?.role || '').replace(/_/g, '-').toLowerCase();
  const isSupplierAdmin = isSupplierAdministrator(roleNormalized);
  const canManagePoEmail = isSupplierAdmin || roleNormalized === 'purchasing-rep';
  const canManageQuickBooks = roleNormalized === 'finance-rep' || isSupplierAdmin;
  const canManagePreferred = canManagePreferredSuppliers(roleNormalized);
  const [poEmailPreference, setPoEmailPreference] = useState({ mode: 'supplier', contactEmail: '' });
  const [poPreferenceContacts, setPoPreferenceContacts] = useState([]);
  const [poPreferenceLoading, setPoPreferenceLoading] = useState(false);
  const [poPreferenceSaving, setPoPreferenceSaving] = useState(false);
  const [poPreferenceWarning, setPoPreferenceWarning] = useState('');
  useEffect(() => {
    if (popupTab !== 'contacts' || !supplierCoreId || !instanceUniqueId) return;
    let active = true;
    setPoPreferenceLoading(true);
    setPoPreferenceWarning('');
    setPoEmailPreference({ mode: 'supplier', contactEmail: '' });
    setPoPreferenceContacts([]);
    Promise.all([
      axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/po-email-preference`, {
        params: { instanceUniqueId }, headers: { accessToken: localStorage.getItem('accessToken') },
      }),
      axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/contacts`, {
        params: { instanceUniqueId }, headers: { accessToken: localStorage.getItem('accessToken') },
      }),
    ]).then(([preference, contacts]) => {
      if (!active) return;
      setPoEmailPreference({
        mode: preference.data?.mode === 'contact' ? 'contact' : 'supplier',
        contactEmail: preference.data?.contactEmail || '',
      });
      const seen = new Set();
      setPoPreferenceContacts((Array.isArray(contacts.data?.contacts) ? contacts.data.contacts : [])
        .filter(contact => {
          const email = String(contact?.email || '').trim().toLowerCase();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) || seen.has(email)) return false;
          seen.add(email);
          return true;
        }));
      setPoPreferenceWarning(preference.data?.warning || '');
    }).catch(() => {
      if (active) setPoPreferenceWarning('Unable to load email preferences. Existing PO email defaults are unaffected.');
    }).finally(() => { if (active) setPoPreferenceLoading(false); });
    return () => { active = false; };
  }, [popupTab, supplierCoreId, instanceUniqueId]);

  const savePoEmailPreference = async () => {
    if (!canManagePoEmail || !supplierCoreId || poPreferenceSaving || poPreferenceLoading) return;
    setPoPreferenceSaving(true);
    try {
      const { data } = await axios.put(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/po-email-preference`,
        { instanceUniqueId, ...poEmailPreference },
        { headers: { accessToken: localStorage.getItem('accessToken') } },
      );
      setPoEmailPreference({ mode: data.mode, contactEmail: data.contactEmail || '' });
      setPoPreferenceWarning('');
      toast.success('Supplier PO email preference saved for this instance.');
    } catch (error) {
      toast.error(error?.response?.data?.error || 'Unable to save PO email preference.');
    } finally { setPoPreferenceSaving(false); }
  };

  const supplierReferences = Array.isArray(supplierDetails?.References)
    ? supplierDetails.References
    : Array.isArray(selectedSupplier?.References)
      ? selectedSupplier.References
      : [];
  const supplierReference = supplierReferences[0] || null;
  const isInstanceCustomSupplier = supplierReferences.some(
    (reference) =>
      reference?.source === "custom-core"
      && String(reference?.id || "") === String(instanceUniqueId || "")
  );
  const isLiveAsiSupplier = !isInstanceCustomSupplier && (
    supplierReferences.some((reference) => String(reference?.source || "").startsWith("asi"))
    || Boolean(selectedSupplier?.AsiNumber)
    || Boolean(selectedSupplier?._live)
  );
  const [isPreferred, setIsPreferred] = useState(Boolean(selectedSupplier?.connected));
  const [preferredSaving, setPreferredSaving] = useState(false);
  useEffect(() => {
    let active = true;
    setIsPreferred(Boolean(selectedSupplier?.connected || supplierTab === "connected"));
    if (!supplierCoreId || !instanceUniqueId) return () => { active = false; };
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/preferred-status`, {
      params: { instanceUniqueId },
      headers: { accessToken: localStorage.getItem("accessToken") },
    }).then(({ data }) => {
      if (active) setIsPreferred(Boolean(data?.preferred));
    }).catch(() => {
      // Retain the directory-provided status if the lookup is unavailable.
    });
    return () => { active = false; };
  }, [selectedSupplier?.connected, supplierCoreId, instanceUniqueId, supplierTab]);
  const archivedInstanceIds = Array.isArray(supplierDetails?.ArchivedInstanceUniqueIds)
    ? supplierDetails.ArchivedInstanceUniqueIds.map(String)
    : [];
  const isArchivedSupplier =
    Boolean(supplierDetails?.archived)
    || archivedInstanceIds.includes(String(instanceUniqueId || ""));
  const [archivingSupplier, setArchivingSupplier] = useState(false);
  const canViewAsiDiagnostic = isLiveAsiSupplier && isSupplierAdmin;
  const productLookupType = supplierReference?.source === "custom-core" ? "custom" : "asi-live";
  // Independent from the ASI directory's existing market state.
  const [asiAssociationMarket, setAsiAssociationMarket] = useState('GLOBAL');
  useEffect(() => {
    let address = selectedSupplier?.Address || {};
    if (typeof address === 'string') { try { address = JSON.parse(address) || {}; } catch (_error) { address = {}; } }
    const country = String(address?.Country || address?.country || '').trim().toLowerCase();
    setAsiAssociationMarket(['canada','can','ca'].includes(country) ? 'CANALL' : 'GLOBAL');
    setAsiCandidates([]);
    setSelectedAsiCandidate(null);
    setAsiLinkId('');
  }, [supplierCoreId]);
  const [asiCandidateQuery, setAsiCandidateQuery] = useState("");
  const [asiCandidates, setAsiCandidates] = useState([]);
  const [asiCandidatesLoading, setAsiCandidatesLoading] = useState(false);
  const [asiSearchError, setAsiSearchError] = useState('');
  useEffect(() => {
    if (!isInstanceCustomSupplier || !isSupplierAdmin || popupTab !== "association" || asiCandidateQuery.trim().length < 2) {
      setAsiCandidates([]); return;
    }
    let active=true;
    setAsiCandidatesLoading(true);
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/get-suppliers`, {
      params:{instanceUniqueId,q: `${asiCandidateQuery.trim()} ${asiAssociationMarket === 'CANALL' ? 'market_segment:CANALL' : ''}`.trim(),tab:'all',page:1,rpp:30},
      headers:{accessToken:localStorage.getItem("accessToken")},
    }).then(({data})=>{
      if(active) {
        const rows=[...(Array.isArray(data?.rows)?data.rows:[]),
          ...(Array.isArray(data?.canadianMatches)?data.canadianMatches:[])];
        const seen=new Set();
        const candidates=rows.filter(row=>{
          const id=String(row?.Id??'');
          if(!row?._live||!id||seen.has(id))return false;
          seen.add(id);return true;
        }).map(row=>({
          id:String(row.Id),name:row.Name,asiNumber:row.AsiNumber,
          market:row.Address?.Country||row.Address?.country||'Unknown',
        }));
        setAsiCandidates(candidates);
        setAsiSearchError(data?.partial
          ? 'Some ASI results are temporarily unavailable.'
          : candidates.length ? '' : 'No ASI suppliers found. Try a different name, ID, or market.');
      }
    }).catch((error)=>{if(active){
      setAsiCandidates([]);
      setAsiSearchError(error?.response?.data?.error||'ASI search is unavailable. Please try again.');
    }})
    .finally(()=>{if(active)setAsiCandidatesLoading(false);});
    return ()=>{active=false;};
  },[instanceUniqueId,isInstanceCustomSupplier,isSupplierAdmin,popupTab,asiCandidateQuery,asiAssociationMarket]);
  const [asiLinkId, setAsiLinkId] = useState("");
  const [linkingAsi, setLinkingAsi] = useState(false);
  const [selectedAsiCandidate, setSelectedAsiCandidate] = useState(null);
  const [linkedIdentityId, setLinkedIdentityId] = useState(null);
  const [associatedSources, setAssociatedSources] = useState([]);
  const handleLinkAsi = async () => {
    if (!isSupplierAdmin || !isInstanceCustomSupplier || !selectedAsiCandidate || String(selectedAsiCandidate.id) !== asiLinkId.trim()) {
      toast.error("Enter a valid ASI supplier ID."); return;
    }
    setLinkingAsi(true);
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/associations/link-custom-asi`,
        {instanceUniqueId,customSupplierId:supplierCoreId,asiSupplierId:asiLinkId.trim()},
        {headers:{accessToken:localStorage.getItem("accessToken")}});
      setLinkedIdentityId(data.identityId);
      setAssociatedSources([{provider:"asi",sourceSupplierId:asiLinkId.trim()},{provider:"custom",sourceSupplierId:String(supplierCoreId)}]);
      toast.success("Custom supplier linked to ASI supplier.");
    } catch(error) { toast.error(error?.response?.data?.error || "Unable to associate suppliers."); }
    finally { setLinkingAsi(false); }
  };
  const handleUnlinkAsi = async (linkedAsiId) => {
    if (!isSupplierAdmin || !isInstanceCustomSupplier || !window.confirm("Unlink this ASI supplier? Contacts and products will remain unchanged.")) return;
    setLinkingAsi(true);
    try {
      await axios.delete(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/associations/link`, {
        data:{instanceUniqueId,provider:"asi",sourceSupplierId:linkedAsiId},
        headers:{accessToken:localStorage.getItem("accessToken")},
      });
      setAssociatedSources(previous=>previous.filter(source=>!(source.provider==="asi" && String(source.sourceSupplierId)===String(linkedAsiId))));
      toast.success("ASI association removed. Supplier records and contacts were preserved.");
    } catch(error){ toast.error(error?.response?.data?.error || "Unable to unlink supplier."); }
    finally { setLinkingAsi(false); }
  };
  const [publicAsiContacts, setPublicAsiContacts] = useState([]);
  const [publicAsiContactError, setPublicAsiContactError] = useState("");
  const [publicAsiContactsLoading, setPublicAsiContactsLoading] = useState(false);
  useEffect(() => {
    if (popupTab !== "contacts" || !isLiveAsiSupplier || !supplierCoreId) return;
    let active=true;
    setPublicAsiContactsLoading(true); setPublicAsiContactError(""); setPublicAsiContacts([]);
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/asi-contacts`, {
      params:{instanceUniqueId},headers:{accessToken:localStorage.getItem("accessToken")}
    }).then(({data})=>{if(active)setPublicAsiContacts(Array.isArray(data?.contacts)?data.contacts:[]);})
      .catch(()=>{if(active)setPublicAsiContactError("ASI contacts could not be loaded.");})
      .finally(()=>{if(active)setPublicAsiContactsLoading(false);});
    return ()=>{active=false};
  },[popupTab,isLiveAsiSupplier,supplierCoreId,instanceUniqueId]);
  const [linkedSupplierContacts, setLinkedSupplierContacts] = useState([]);
  const [linkedSupplierError, setLinkedSupplierError] = useState("");
  useEffect(() => {
    if (!['contacts', 'association'].includes(popupTab) || !supplierCoreId || !instanceUniqueId) return;
    let active = true;
    setLinkedSupplierContacts([]);
    setLinkedSupplierError("");
    const provider = isInstanceCustomSupplier ? "custom" : "asi";
    axios.get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/associations/resolve`, {
      params: { instanceUniqueId, provider, sourceSupplierId: supplierCoreId },
      headers: { accessToken: localStorage.getItem("accessToken") },
    }).then(({ data }) => {
      if (active) { setLinkedSupplierContacts(Array.isArray(data?.linkedCustomContacts) ? data.linkedCustomContacts : []); setLinkedIdentityId(data?.identity?.id || null); setAssociatedSources(Array.isArray(data?.sources) ? data.sources : []); }
    }).catch(() => { if (active) setLinkedSupplierError("Linked supplier contacts could not be loaded."); });
    return () => { active = false; };
  }, [popupTab, supplierCoreId, instanceUniqueId, isInstanceCustomSupplier]);
  const supplierContacts = Array.isArray(supplierDetails?.clientContacts)
    ? supplierDetails.clientContacts
    : Array.isArray(supplierDetails?.contacts)
    ? supplierDetails.contacts
    : [];
  const asiContacts = normalizeAsiContacts(
    asiSupplierDetail?.response?.Contacts ?? asiSupplierDetail?.response?.contacts
  );
  const asiOverview = normalizeAsiOverview(isLiveAsiSupplier ? asiSupplierDetail?.response : null);
  const overviewAddresses = asiOverview.addresses.length
    ? asiOverview.addresses
    : (formatAsiAddress(selectedSupplier?.Address)
      ? [{ label: "Primary Address", formatted: formatAsiAddress(selectedSupplier.Address) }]
      : []);

  const handleArchiveSupplier = async () => {
    if (!isSupplierAdmin || !isInstanceCustomSupplier || isArchivedSupplier || archivingSupplier) return;

    const name = supplierDetails?.Name || selectedSupplier?.Name || "this supplier";
    const confirmed = window.confirm(
      `Archive ${name}?\n\nThis custom supplier will be removed from live supplier selections and custom-supplier importing for this instance. Historical purchase orders, products, and supplier records will remain intact.`
    );
    if (!confirmed) return;

    setArchivingSupplier(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/archive`,
        { instanceUniqueId },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      const archivedSupplier = {
        ...supplierDetails,
        ...(data?.supplier || {}),
        archived: true,
      };
      setSupplierDetails(archivedSupplier);
      onSupplierArchived?.(archivedSupplier);
      toast.success("Supplier archived.");
    } catch (error) {
      toast.error(error?.response?.data?.error || "Unable to archive supplier.");
    } finally {
      setArchivingSupplier(false);
    }
  };

  const [isImporting, setIsImporting] = useState(false);
  const [importedCount, setImportedCount] = useState(null);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    const previousPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);

    document.body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      const currentPadding = Number.parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
      document.body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
    }

    return () => {
      document.body.style.overflow = previousOverflow;
      document.body.style.paddingRight = previousPaddingRight;
    };
  }, []);

  useEffect(() => {
    setSupplierDetails(selectedSupplier);
  }, [selectedSupplier]);

  const resolveProductImageUrls = (product) => {
    const candidates = [product?.ImageUrl, ...(Array.isArray(product?.Images) ? product.Images : [])];
    return [...new Set(candidates.map((entry) => {
      const raw = typeof entry === "string" ? entry : (entry?.Url || entry?.url || entry?.ImageUrl || "");
      if (!raw) return "";
      if (productLookupType === "custom" || /^https?:\/\//i.test(raw)) return raw;
      return `https://api.asicentral.com/v1/${raw}?size=normal`;
    }).filter(Boolean))];
  };
  const [productImageIndices, setProductImageIndices] = useState({});
  const [failedProductImages, setFailedProductImages] = useState({});
  const changeProductImage = (key, direction, count) => {
    setProductImageIndices((prev) => ({
      ...prev, [key]: ((prev[key] || 0) + direction + count) % count,
    }));
  };

  const resolveProductPrice = (product) => {
    const value =
      product?.Price?.Cost ??
      product?.Price?.Price ??
      product?.Prices?.[0]?.Cost ??
      product?.Prices?.[0]?.Price ??
      null;
    const currency =
      product?.Price?.CurrencyCode ||
      product?.Prices?.[0]?.CurrencyCode ||
      product?.Currency ||
      "CAD";
    return value != null ? { value: Number(value), currency } : null;
  };

  const resolveProductSku = (product) =>
    product?.Number ||
    product?.SKU ||
    (Array.isArray(product?.Numbers) ? product.Numbers[0] : "") ||
    "";

  const resolveProductSupplierName = (product) =>
    product?.Supplier?.Name ||
    product?.SupplierName ||
    (typeof product?.Supplier === "string" ? product.Supplier : "") ||
    selectedSupplier?.Name ||
    "";

  const resolveProductInventoryLabel = (product) => {
    const summary = product?.InventorySummary || {};
    if (summary.hasExactQuantities && summary.totalQuantityAvailable != null) {
      return `${summary.totalQuantityAvailable} available`;
    }
    if (summary.isCloseout) return "Closeout";
    if (summary.isAvailable === true) return "Available";
    if (summary.isAvailable === false) return "Unavailable";
    if (product?.Availability?.isAvailable === true || product?.HasInventory === true) return "Available";
    if (product?.Availability?.isAvailable === false || product?.HasInventory === false) return "Unavailable";
    return "Availability may vary";
  };

  const loadSupplierContacts = async () => {
    if (!supplierCoreId || !instanceUniqueId) return;

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/contacts`,
        {
          params: { instanceUniqueId },
          headers: { accessToken: localStorage.getItem("accessToken") },
        }
      );

      const contacts = Array.isArray(data?.contacts) ? data.contacts : [];
      setSupplierDetails((prev) => ({
        ...(prev || selectedSupplier || {}),
        clientContacts: contacts,
        contacts,
      }));
    } catch (error) {
      console.error("Failed to load supplier contacts", error);
      toast.error("Failed to load supplier contacts.");
    }
  };

  const loadAsiDiagnostic = useCallback(async () => {
    if (!supplierCoreId || !instanceUniqueId || !canViewAsiDiagnostic) return;

    const requestSequence = ++asiRequestSequence.current;

    setAsiDiagnosticLoading(true);
    setAsiDiagnosticError("");

    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/asi-diagnostic`,
        {
          params: { instanceUniqueId },
          headers: { accessToken: localStorage.getItem("accessToken") },
        }
      );
      if (requestSequence === asiRequestSequence.current) setAsiSupplierDetail(data);
    } catch (error) {
      const message = error?.response?.data?.error || "Failed to load ASI diagnostic response.";
      if (requestSequence === asiRequestSequence.current) {
        setAsiSupplierDetail(null);
        setAsiDiagnosticError(message);
      }
    } finally {
      if (requestSequence === asiRequestSequence.current) setAsiDiagnosticLoading(false);
    }
  }, [canViewAsiDiagnostic, instanceUniqueId, supplierCoreId]);
  

  // product-list state for the “Products” tab:
  const [prodPage,        setProdPage]        = useState(1);
  const [prodTotalPages,  setProdTotalPages]  = useState(0);
  const [prodResults,     setProdResults]     = useState([]);
  const [prodLoading,     setProdLoading]     = useState(false);

  // Buffered loader for products (prevents flicker)
  const [prodLoadingBuffered, setProdLoadingBuffered] = useState(false);

  useEffect(() => {
    // show after a short delay; keep visible for a minimum time on hide
    const SHOW_DELAY_MS = 200;   // wait before showing loader
    const HIDE_DELAY_MS = 350;   // keep loader on screen a bit after load

    let showTimer, hideTimer;

    if (prodLoading) {
      hideTimer && clearTimeout(hideTimer);
      showTimer = setTimeout(() => setProdLoadingBuffered(true), SHOW_DELAY_MS);
    } else {
      showTimer && clearTimeout(showTimer);
      hideTimer = setTimeout(() => setProdLoadingBuffered(false), HIDE_DELAY_MS);
    }

    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [prodLoading]);

  
  useEffect(() => {
    if (!selectedSupplier) return;
    const img = new Image();
    img.src = bannerUrl;
    img.onload = () => setBannerError(false);
    img.onerror = () => setBannerError(true);
  }, [bannerUrl, selectedSupplier]);

  const handleImport = async () => {
    setIsImporting(true);
    setImportedCount(null);
  
    try {
      const params = {};
  
      // If Canada is selected, append the market_segment query param
      if (market === "CANALL") {
        params.market_segment = "CANALL";
      }
  
      const { data } = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/products/suppliers/${supplierCoreId}/import-products`,
        { instanceUniqueId },
        {
          params,
          headers: { accessToken: localStorage.getItem("accessToken") },
        }
      );

      startProgressStream(supplierCoreId);
  
      setImportedCount(data.importedCount);
    } catch (err) {
      console.error("Import error:", err);
      alert("Failed to import products. Check console for details.");
    } finally {
      setIsImporting(false);
    }
  };
  
  
  useEffect(() => {
    if (popupTab !== "products") return;

    async function loadProducts() {
      setProdLoading(true);

      try {
        let reference = selectedSupplier.References?.[0] || 'custom-core'; // assuming first reference is used
    
        const lookupType = reference.source === 'custom-core' ? 'core-connect' : 'asi-live';
    
        let params = {
          lookupType,
          supplierId: selectedSupplier.Id, // always include
          page: prodPage,
          rpp: 20,
          sort: "DFLT",
          q: ""
        };

        if (lookupType === 'asi-live' && market === 'CANALL') {
          params.q = 'market_segment:CANALL';
        }
    
        if (lookupType === 'asi-live') {
          params.supplierId = selectedSupplier.Id;
        } else if (lookupType === 'core-connect') {
          params.instanceUniqueId = reference.id;
        }

        const { data } = await axios.get(
          `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/get-products`,
          { params }
        );
    
        setProdResults(data.Results);
        setProdTotalPages(data.TotalPages);
      } catch (err) {
        console.error("Error loading products:", err);
        alert("Failed to load products");
      } finally {
        setProdLoading(false);
      }
    }
    
    loadProducts();
  }, [popupTab, prodPage, selectedSupplier.AsiNumber, productLookupType, market, supplierCoreId]);

  useEffect(() => {
    if (popupTab !== "contacts") return;
    loadSupplierContacts();
  }, [popupTab, supplierCoreId, instanceUniqueId]);

  useEffect(() => {
    asiRequestSequence.current += 1;
    setAsiSupplierDetail(null);
    setAsiDiagnosticError("");
    setAsiDiagnosticLoading(false);

    if (canViewAsiDiagnostic) loadAsiDiagnostic();

    return () => {
      asiRequestSequence.current += 1;
    };
  }, [supplierCoreId, isLiveAsiSupplier, canViewAsiDiagnostic, loadAsiDiagnostic]);

  useEffect(() => {
    if (popupTab !== "asi-diagnostic") return;
    if (!canViewAsiDiagnostic) {
      setPopupTab("overview");
      return;
    }
  }, [canViewAsiDiagnostic, popupTab]);

  const loadShippingAccounts = async () => {
    if (!selectedSupplier?.id) return;
    setShippingAccountsLoading(true);
    try {
      const response = await getAllClientAccounts({
        instanceUniqueId,
        supplierId: selectedSupplier.id,
      });
      setShippingAccounts(response?.data || []);
    } catch (error) {
      console.error("Failed to load supplier shipping accounts", error);
      setShippingAccounts([]);
    } finally {
      setShippingAccountsLoading(false);
    }
  };

  useEffect(() => {
    if (popupTab !== "shipping") return;
    loadShippingAccounts();
  }, [popupTab, selectedSupplier?.id, instanceUniqueId]);

  useEffect(() => {
    if ((popupTab === 'quickbooks' && !canManageQuickBooks) ||
        (['api-integration', 'asi-diagnostic', 'association'].includes(popupTab) && !isSupplierAdmin)) {
      setPopupTab('overview');
      return;
    }
    if (popupTab === 'asi-diagnostic' && !canViewAsiDiagnostic) {
      setPopupTab('overview');
    }
  }, [popupTab, isSupplierAdmin, canManageQuickBooks, canViewAsiDiagnostic]);

  const handleDisconnectQbo = async () => {
    const supplierId = supplierDetails?.id || supplierDetails?.Id;
    if (!supplierId || disconnectingQbo) return;
    if (!window.confirm("Disconnect this supplier from QuickBooks?")) return;

    setDisconnectingQbo(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierId}/qbo/link`,
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      setSupplierDetails((prev) => ({
        ...prev,
        qbo_ref_id: null,
        qboRefId: null,
        qbo_link_status: "unmapped",
        accountingRef: null,
      }));
      toast.success("QuickBooks vendor disconnected.");
    } catch (err) {
      toast.error(err?.response?.data?.error || "Failed to disconnect QuickBooks vendor.");
    } finally {
      setDisconnectingQbo(false);
    }
  };

  const handleCopyAsiDiagnosticJson = async () => {
    if (!asiSupplierDetail?.response) return;
    try {
      await navigator.clipboard.writeText(JSON.stringify(asiSupplierDetail.response, null, 2));
      toast.success("ASI diagnostic JSON copied.");
    } catch (error) {
      toast.error("Unable to copy ASI diagnostic JSON.");
    }
  };

  const handleConnectSupplier = async () => {
    if (!supplierCoreId || isPreferred || preferredSaving) return;
    setPreferredSaving(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/connect`,
        { instanceUniqueId, coreSupplierId: supplierCoreId },
        { headers: { accessToken: localStorage.getItem("accessToken") } }
      );
      setIsPreferred(true);
      onPreferredChanged?.(supplierCoreId, true);
      toast.success("Supplier added to preferred suppliers.", { autoClose: 3500 });
    } catch (err) {
      toast.error(err?.response?.data?.error || "Unable to set preferred supplier.", { autoClose: 5000 });
    } finally {
      setPreferredSaving(false);
    }
  };

  const handlePreferredAction = async () => {
    if (!canManagePreferred || !supplierCoreId || preferredSaving) return;
    if (!isPreferred) {
      await handleConnectSupplier();
      return;
    }
    const confirmed = window.confirm(
      `Remove "${supplierDetails?.Name || selectedSupplier?.Name || "this supplier"}" from Preferred Suppliers?\\n\\nThis will remove its preferred designation for this instance only. The supplier and historical records will remain available.`
    );
    if (!confirmed) return;
    setPreferredSaving(true);
    try {
      const { data } = await axios.delete(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/preferred`,
        {
          data: { instanceUniqueId },
          headers: { accessToken: localStorage.getItem("accessToken") },
        }
      );
      if (!data?.success) throw new Error("Preferred supplier removal could not be confirmed.");
      setIsPreferred(false);
      onPreferredChanged?.(supplierCoreId, false);
      toast.success("Supplier removed from preferred suppliers.", { autoClose: 3500 });
    } catch (error) {
      toast.error(error?.response?.data?.error || error?.message || "Unable to remove preferred supplier.", { autoClose: 5000 });
    } finally {
      setPreferredSaving(false);
    }
  };

  const handleSaveContact = async (values, { resetForm }) => {
    if (!supplierCoreId) return;

    setContactSaving(true);
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_NODEJS_SERVER_URL}/suppliers/${supplierCoreId}/contacts`,
        {
          instanceUniqueId,
          contact: values,
        },
        {
          headers: { accessToken: localStorage.getItem("accessToken") },
        }
      );

      const contacts = Array.isArray(data?.contacts) ? data.contacts : [];
      setSupplierDetails((prev) => ({
        ...(prev || selectedSupplier || {}),
        clientContacts: contacts,
        contacts,
      }));
      toast.success("Supplier contact added.");
      resetForm();
      setContactDialogOpen(false);
    } catch (error) {
      console.error("Failed to save supplier contact", error);
      toast.error(error?.response?.data?.error || "Failed to add supplier contact.");
    } finally {
      setContactSaving(false);
    }
  };

  const openProductDetails = (product) => {
    setPopupProductId(product?.Id || product?.id || null);
    setProductPopupOpen(true);
  };

  const closeProductDetails = () => {
    setProductPopupOpen(false);
    setPopupProductId(null);
  };

  const handleCloseSupplierPopup = () => setShowViewPopup(false);

  const normalizedRole = authState.role.replace(/_/g, '-');
  const currentRoleLabel =
    ROLE_OPTIONS.find(opt => opt.value === normalizedRole)?.label
    || authState.role;

  useEffect(() => {
    if (!selectedSupplier) return;
    const img = new Image();
    img.src = bannerUrl;
    img.onload = () => setBannerError(false);
    img.onerror = () => setBannerError(true);
  }, [bannerUrl, selectedSupplier]);

  // build the primary banner URL
  const bannerUrls = `/supplier-reference/${supplierName}/banner.jpg`;


  return (
    <div className="popup supplier" style={{ padding: "12px", boxSizing: "border-box" }}>
      <div className="popup_inner supplier-popup-shell">

        {/*
        JSON.stringify(selectedSupplier)
        */}
  
  <div
  className="featured-banner"
  style={{
    backgroundImage: !bannerError ? `url("${bannerUrls}")` : "none",
    position: "relative"
  }}
>
  {/* If no banner, show supplier name in bottom-left */}
  {bannerError && (
    <div
      style={{
        position: "absolute",
        bottom: "10px",
        left: "15px",
        color: "#333",
        fontSize: "2.3rem",
        fontWeight: 500,
        fontFamily: "Nunito"
      }}
    >
      {supplierName}
    </div>
  )}
</div>

{/* Red bar should always exist */}
<h1 className="featured-heading">
  <div className="supplier-logo">
    <img
      src={`/supplier-reference/${supplierName}/logo.png`}
      alt={`${supplierName} logo`}
      onLoad={(e) => {
        // fade-in once loaded
        e.target.style.opacity = 1;
      }}
      onError={(e) => {
        // hide completely if it fails
        e.target.style.display = "none";
      }}
      className="supplier-logo-img custom-logo"
      style={{
        opacity: 0,                // start invisible
        transition: "opacity 0.4s ease", // fade-in animation
        objectFit: "contain"
      }}
    />
  </div>
  <span>Supplier Details</span>
  <IconButton
    aria-label="close"
    onClick={handleCloseSupplierPopup}
    sx={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", color: "common.white" }}
  >
    <CloseIcon />
  </IconButton>
</h1>




        <div className="popup-content">
          <div className="supplier-details">
          <DialogTitle>
        <Tabs
          value={popupTab}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          onChange={(_, v) => {
            setPopupTab(v);
            if (v === "products") setProdPage(1);
          }}
        >
          <Tab label="Overview" value="overview" />
          <Tab label="Products" value="products" />
          <Tab label="Contacts" value="contacts" />
          {isInstanceCustomSupplier && isSupplierAdmin && <Tab label={
            <Stack direction="row" spacing={0.8} alignItems="center">
              <span>Supplier Association</span>
              <Box component="span" sx={{width:9,height:9,borderRadius:'50%',bgcolor:associatedSources.some(source=>source.provider==='asi')?'success.main':'error.main'}} />
            </Stack>
          } value="association" />}
          <Tab label="Shipping Accounts" value="shipping" />
          {canManageQuickBooks && <Tab label="QuickBooks Connection" value="quickbooks" />}
          {isSupplierAdmin && <Tab label="API Integration" value="api-integration" />}
          {canViewAsiDiagnostic && <Tab label="ASI Diagnostic" value="asi-diagnostic" />}
        </Tabs>
      </DialogTitle>

      {popupTab === "products" && (
        <div className="supplier-product-container">
  {prodLoadingBuffered ? (
    <Box className="supplier-products-grid"
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
        gap: 2,
        mt: 2,
      }}
    >
      {Array.from({ length: 8 }).map((_, i) => (
        <Box
          key={i}
          sx={{
            border: "1px solid",
            borderColor: "divider",
            borderRadius: "10px",
            overflow: "hidden",
            bgcolor: "background.paper",
          }}
        >
          <Skeleton variant="rectangular" height={150} />
          <Box sx={{ p: 1.25 }}>
            <Skeleton width="85%" height={16} sx={{ mb: 0.75 }} />
            <Skeleton width="55%" height={12} sx={{ mb: 0.5 }} />
            <Skeleton width="40%" height={12} />
          </Box>
        </Box>
      ))}
    </Box>
  ) : prodResults.length > 0 ? (
    <>
      <Box className="supplier-products-grid"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(190px, 1fr))",
          gap: 2,
          mt: 2,
        }}
      >
        {prodResults.map(product => {
          const imageUrls = resolveProductImageUrls(product);
          const imageKey = String(product.Id || product.id || product.Number || product.SKU || product.Name);
          const imageIndex = Math.min(productImageIndices[imageKey] || 0, Math.max(imageUrls.length - 1, 0));
          const imageUrl = imageUrls[imageIndex] || "";
          const imageFailed = Boolean(failedProductImages[`${imageKey}:${imageIndex}`]);
          const productName = product.Name || "Unnamed Product";
          const sku = resolveProductSku(product);
          const supplierName = resolveProductSupplierName(product);
          const priceObj = resolveProductPrice(product);
          const inventoryLabel = resolveProductInventoryLabel(product);

          return (
            <Tooltip
              key={product.Id || product.id}
              placement="top"
              arrow
              title={
                <Box sx={{ maxWidth: 220, p: 0.5 }}>
                  <Typography variant="caption" fontWeight={700} display="block">
                    {productName}
                  </Typography>
                  {sku && (
                    <Typography variant="caption" display="block" sx={{ opacity: 0.75 }}>
                      SKU: {sku}
                    </Typography>
                  )}
                  {supplierName && (
                    <Typography variant="caption" display="block" sx={{ opacity: 0.75 }}>
                      Supplier: {supplierName}
                    </Typography>
                  )}
                  {priceObj && (
                    <Typography variant="caption" display="block" sx={{ opacity: 0.75 }}>
                      Price: {priceObj.currency} ${priceObj.value.toFixed(2)}
                    </Typography>
                  )}
                </Box>
              }
            >
              <Box
                className="supplier-product-card"
                onClick={() => openProductDetails(product)}
                sx={{
                  position: "relative",
                  border: "1.5px solid",
                  borderColor: "divider",
                  borderRadius: "10px",
                  bgcolor: "background.paper",
                  overflow: "hidden",
                  cursor: "pointer",
                  transition: "box-shadow 0.18s ease, transform 0.18s ease, border-color 0.18s ease",
                  "&:hover": {
                    boxShadow: "0 4px 18px rgba(0,0,0,0.10)",
                    transform: "translateY(-2px)",
                    borderColor: "primary.main",
                  },
                }}
              >
                <Chip
                  label={inventoryLabel}
                  size="small"
                  sx={{
                    position: "absolute",
                    top: 6,
                    left: 6,
                    zIndex: 2,
                    height: 20,
                    fontSize: "0.62rem",
                    fontWeight: 800,
                    bgcolor: inventoryLabel === "Available" ? "#dcfce7" : "#f1f5f9",
                    color: inventoryLabel === "Available" ? "#166534" : "#475569",
                    border: "1px solid",
                    borderColor: inventoryLabel === "Available" ? "#86efac" : "#cbd5e1",
                    "& .MuiChip-label": { px: "7px" },
                  }}
                />

                <Box
                  sx={{
                    width: "100%",
                    height: 150,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    bgcolor: "#f8fafc",
                    borderBottom: "1px solid",
                    borderColor: "divider",
                    overflow: "hidden",
                  }}
                >
                  {imageUrl && !imageFailed ? (
                    <Box component="img" src={imageUrl} alt={productName}
                      sx={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
                      onError={() => setFailedProductImages((prev) => ({ ...prev, [`${imageKey}:${imageIndex}`]: true }))} />
                  ) : (
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8" }}>
                      <ImageNotSupportedIcon sx={{ fontSize: 30 }} />
                    </Box>
                  )}
                  {imageUrls.length > 1 && (
                    <Box className="supplier-product-gallery-controls" onClick={(event) => event.stopPropagation()}>
                      <IconButton size="small" aria-label="Previous product image"
                        onClick={() => changeProductImage(imageKey, -1, imageUrls.length)}>
                        <ChevronLeftIcon fontSize="small" />
                      </IconButton>
                      <Typography variant="caption">{imageIndex + 1}/{imageUrls.length}</Typography>
                      <IconButton size="small" aria-label="Next product image"
                        onClick={() => changeProductImage(imageKey, 1, imageUrls.length)}>
                        <ChevronRightIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  )}
                </Box>

                <Box sx={{ p: 1.25 }}>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    sx={{
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      lineHeight: 1.35,
                      color: "text.primary",
                      mb: 0.5,
                      fontSize: "0.8125rem",
                    }}
                  >
                    {productName}
                  </Typography>

                  {sku && (
                    <Typography
                      variant="caption"
                      sx={{
                        color: "text.disabled",
                        fontFamily: "monospace",
                        fontSize: "0.68rem",
                        display: "block",
                      }}
                    >
                      {sku}
                    </Typography>
                  )}

                  {supplierName && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.4, mt: 0.5 }}>
                      <StorefrontIcon sx={{ fontSize: 11, color: "text.disabled" }} />
                      <Typography
                        variant="caption"
                        sx={{ color: "text.disabled", fontSize: "0.68rem", lineHeight: 1 }}
                      >
                        {supplierName}
                      </Typography>
                    </Box>
                  )}

                  {priceObj ? (
                    <Typography
                      variant="caption"
                      fontWeight={700}
                      sx={{ display: "block", mt: 0.5, color: "primary.main", fontSize: "0.78rem" }}
                    >
                      {priceObj.currency} ${priceObj.value.toFixed(2)}
                    </Typography>
                  ) : (
                    <Typography
                      variant="caption"
                      sx={{ display: "block", mt: 0.5, color: "text.disabled", fontSize: "0.78rem" }}
                    >
                      QUR
                    </Typography>
                  )}
                </Box>
              </Box>
            </Tooltip>
          );
        })}
      </Box>

      <Box className="supplier-products-pagination">
        <Box>
          <Typography variant="body2" fontWeight={600} color="text.primary">
            Showing {(prodPage - 1) * 20 + 1}–{(prodPage - 1) * 20 + prodResults.length} products
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Page {prodPage} of {Math.max(prodTotalPages, 1)}
          </Typography>
        </Box>
        <Pagination
          count={prodTotalPages}
          page={prodPage}
          onChange={(_, p) => setProdPage(p)}
          shape="rounded"
          color="primary"
          size="small"
          siblingCount={1}
          boundaryCount={1}
          showFirstButton
          showLastButton
        />
      </Box>
    </>
  ) : (
    <p>No products found for this supplier.</p>
  )}
</div>

      )}


        

        {popupTab === "overview" && isInstanceCustomSupplier && (
          <Box className="supplier-edit-card" sx={{ p: { xs: 2, sm: 3 }, mx: { xs: 1, sm: 2 }, my: 2, border: "1px solid", borderColor: "divider", borderRadius: 2, bgcolor: "background.paper" }}>
            {isSupplierAdmin && !isArchivedSupplier && !supplierEditMode && (
              <Tooltip title="Edit supplier details" arrow>
                <IconButton
                  className="supplier-edit-pencil"
                  size="small"
                  aria-label="Edit supplier details"
                  onClick={beginSupplierEdit}
                >
                  <EditOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
            <Box sx={{ mb: 3, pr: 5 }}>
              <Box className="supplier-source-heading" sx={{ mb: "6px !important" }}>
                <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.35 }}>
                  {supplierDetails?.Name || selectedSupplier?.Name || "Supplier Details"}
                </Typography>
                <Tooltip arrow title={`This supplier was added specifically for ${companyName || "your company"}. Authorized administrators can update its details.`}>
                  <Chip size="small" label="Custom Core" variant="outlined" sx={{ cursor: "help" }} />
                </Tooltip>
                {isPreferred && <Chip size="small" color="success" label="Preferred" />}
              </Box>
              <Typography variant="body2" color="text.secondary">Supplier Details</Typography>
            </Box>
            <Box className="supplier-edit-fields">
              {[
                ["Name", "Supplier Name"],
                ["Email", "Email"],
                ["phone", "Phone"],
                ["website", "Website"],
              ].map(([key, label]) => (
                <Box key={key} className="supplier-edit-field">
                  <TextField label={label} fullWidth size="small"
                    value={supplierEditMode ? (supplierDraft[key] || "") : (
                      key === "phone" ? (supplierDetails?.Phone?.Work || selectedSupplier?.Phone?.Work || "") :
                      key === "website" ? (supplierDetails?.Websites?.[0] || selectedSupplier?.Websites?.[0] || "") :
                      (supplierDetails?.[key] || selectedSupplier?.[key] || "")
                    )}
                    InputProps={{ readOnly: !supplierEditMode }}
                    sx={{ "& .MuiOutlinedInput-root": { bgcolor: "background.paper", borderRadius: 1.5 }, "& .MuiInputBase-input": { color: "text.primary", WebkitTextFillColor: "currentColor" } }}
                    onChange={(event) => setSupplierDraft((prev) => ({ ...prev, [key]: event.target.value }))}
                  />
                </Box>
              ))}
              <Box className="supplier-edit-field">
                <TextField select label="Supplier Type" fullWidth size="small"
                  value={supplierEditMode ? supplierDraft.supplierType : supplierClassification}
                  disabled={!supplierEditMode}
                  sx={{ "& .MuiOutlinedInput-root": { bgcolor: "background.paper", borderRadius: 1.5 }, "& .MuiInputBase-input": { color: "text.primary", WebkitTextFillColor: "currentColor" } }}
                  onChange={(event) => {
                    if (supplierEditMode) setSupplierDraft((prev) => ({ ...prev, supplierType: event.target.value }));
                  }}>
                  <MenuItem value="standard">Standard Supplier</MenuItem>
                  <MenuItem value="freight">Freight / Shipping Provider</MenuItem>
                  <MenuItem value="service">Service Provider</MenuItem>
                </TextField>
              </Box>
            </Box>
            {supplierEditMode && (
              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5, mt: 3 }}>
                <Button disabled={supplierSaving} onClick={() => setSupplierEditMode(false)}>Cancel</Button>
                <Button variant="contained" disabled={supplierSaving} onClick={saveSupplierDetails}>
                  {supplierSaving ? "Saving..." : "Save Changes"}
                </Button>
              </Box>
            )}
          </Box>
        )}
        {popupTab === "overview" && (
          isLiveAsiSupplier && canViewAsiDiagnostic && (asiDiagnosticLoading || (!asiSupplierDetail && !asiDiagnosticError)) ? (
            <Box className="supplier-asi-overview-loader" sx={{ minHeight: 250, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 1.5 }}>
              <CircularProgress size={30} />
              
            </Box>
          ) : isLiveAsiSupplier && canViewAsiDiagnostic && asiDiagnosticError ? (
            <Alert severity="warning" sx={{ m: 2 }}>
              ASI supplier details could not be loaded. {asiDiagnosticError}
              <Button size="small" onClick={loadAsiDiagnostic} sx={{ ml: 1 }}>Retry</Button>
            </Alert>
          ) : isLiveAsiSupplier ? (
          <Box className="supplier-overview" sx={{ p: 1 }}>
            <Box>
              <Box className="supplier-source-heading">
                <Typography variant="h5" fontWeight={700}>{selectedSupplier.Name || asiSupplierDetail?.response?.Name}</Typography>
                <Tooltip arrow title="ASI Supplier information comes from the ASI catalogue database and is read-only in Elite Core.">
                  <Chip size="small" label="ASI Supplier" variant="outlined" sx={{ cursor: "help" }} />
                </Tooltip>
                {isPreferred && <Chip size="small" color="success" label="Preferred" />}
              </Box>
              {selectedSupplier.AsiNumber && <Typography color="text.secondary">ASI #{selectedSupplier.AsiNumber}</Typography>}
            </Box>

            <Box className="supplier-profile-grid">
              <Box className="supplier-profile-card" sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>Contact &amp; Ordering</Typography>
                {(asiOverview.generalEmail || selectedSupplier.Email) && <Typography variant="body2"><strong>General Email:</strong>{" "}<a href={`mailto:${asiOverview.generalEmail || selectedSupplier.Email}`}>{asiOverview.generalEmail || selectedSupplier.Email}</a></Typography>}
                {asiOverview.ordersEmail && <Typography variant="body2"><strong>Orders Email:</strong>{" "}<a href={`mailto:${asiOverview.ordersEmail}`}>{asiOverview.ordersEmail}</a></Typography>}
                {asiOverview.artworkEmail && <Typography variant="body2"><strong>Artwork Email:</strong>{" "}<a href={`mailto:${asiOverview.artworkEmail}`}>{asiOverview.artworkEmail}</a></Typography>}
                {(asiOverview.phone || selectedSupplier.Phone?.Work) && <Typography variant="body2"><strong>Phone:</strong> {asiOverview.phone || selectedSupplier.Phone.Work}</Typography>}
                {(asiOverview.tollFree || selectedSupplier.Phone?.TollFree) && <Typography variant="body2"><strong>Toll-Free:</strong> {asiOverview.tollFree || selectedSupplier.Phone.TollFree}</Typography>}
                {(asiOverview.fax || selectedSupplier.Fax) && <Typography variant="body2"><strong>Fax:</strong> {asiOverview.fax || selectedSupplier.Fax}</Typography>}
                {asiOverview.officeHours && <Typography variant="body2"><strong>Office Hours:</strong> {asiOverview.officeHours}</Typography>}
                {Array.isArray(selectedSupplier.Websites) && selectedSupplier.Websites.length > 0 && (
                  <Typography variant="body2"><strong>Website:</strong>{" "}{selectedSupplier.Websites.map((site, index) => (
                    <React.Fragment key={site}><a href={site.startsWith("http") ? site : `https://${site}`} target="_blank" rel="noopener noreferrer">{site}</a>{index < selectedSupplier.Websites.length - 1 ? ", " : ""}</React.Fragment>
                  ))}</Typography>
                )}
              </Box>

              <Box className="supplier-profile-card" sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2 }}>
                <Typography variant="h6" sx={{ mb: 1 }}>Supplier Information</Typography>
                {selectedSupplier.AsiNumber && <Typography variant="body2"><strong>ASI Number:</strong> {selectedSupplier.AsiNumber}</Typography>}
                {asiOverview.type && <Typography variant="body2"><strong>Type:</strong> {asiOverview.type}</Typography>}
                {asiOverview.yearEstablished && <Typography variant="body2"><strong>Year Established:</strong> {asiOverview.yearEstablished}</Typography>}
                {asiOverview.yearInIndustry && <Typography variant="body2"><strong>Year in Industry:</strong> {asiOverview.yearInIndustry}</Typography>}
                {asiOverview.totalEmployees && <Typography variant="body2"><strong>Employees:</strong> {asiOverview.totalEmployees}</Typography>}
                {asiOverview.productionTime && <Typography variant="body2"><strong>Production Time:</strong> {asiOverview.productionTime}</Typography>}
                {selectedSupplier.Products > 0 && <Typography variant="body2"><strong>Products:</strong> {selectedSupplier.Products}</Typography>}
                {selectedSupplier.ServiceCount > 0 && <Typography variant="body2"><strong>Services:</strong> {selectedSupplier.ServiceCount}</Typography>}
                {selectedSupplier.ListDate && <Typography variant="body2"><strong>Listed Since:</strong> {new Date(selectedSupplier.ListDate).toLocaleDateString()}</Typography>}
              </Box>
            </Box>

            {overviewAddresses.length > 0 && <Box><Typography variant="h6" sx={{ mb: 1 }}>Addresses</Typography><Box className="supplier-address-grid">{overviewAddresses.map((address) => <Box className="supplier-address-card" key={address.label} sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, p: 1.5 }}><Typography variant="subtitle2">{address.label}</Typography><Typography variant="body2" color="text.secondary">{address.formatted}</Typography>{importedDateLabel(address) && <Typography variant="caption" color="text.secondary">Added {importedDateLabel(address)}</Typography>}</Box>)}</Box></Box>}

            {(asiOverview.functions.length > 0 || asiOverview.imprintingMethods.length > 0 || asiOverview.distributionPolicy || asiOverview.marketingPolicy) && (
              <Box className="supplier-secondary-grid">
                {(asiOverview.functions.length > 0 || asiOverview.imprintingMethods.length > 0) && <Box className="supplier-profile-card" sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2 }}><Typography variant="h6" sx={{ mb: 1.25 }}>Supplier Capabilities</Typography>{asiOverview.functions.length > 0 && <Box sx={{ mb: asiOverview.imprintingMethods.length ? 1.5 : 0 }}><Typography variant="subtitle2" sx={{ mb: 0.75 }}>Functions</Typography><Stack className="supplier-chip-list" direction="row" useFlexGap flexWrap="wrap" spacing={0.75}>{asiOverview.functions.map((value) => <Chip key={value} label={value} size="small" sx={{ width: "fit-content", flex: "0 0 auto" }} />)}</Stack></Box>}{asiOverview.imprintingMethods.length > 0 && <Box><Typography variant="subtitle2" sx={{ mb: 0.75 }}>Imprinting Methods</Typography><Stack className="supplier-chip-list" direction="row" useFlexGap flexWrap="wrap" spacing={0.75}>{asiOverview.imprintingMethods.map((value) => <Chip key={value} label={value} size="small" variant="outlined" sx={{ width: "fit-content", flex: "0 0 auto" }} />)}</Stack></Box>}</Box>}
                {(asiOverview.distributionPolicy || asiOverview.marketingPolicy) && <Box className="supplier-profile-card" sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2 }}><Typography variant="h6" sx={{ mb: 1.25 }}>Supplier Policies</Typography>{asiOverview.distributionPolicy && <Box className="supplier-policy-copy" sx={{ mb: asiOverview.marketingPolicy ? 1.25 : 0 }}><Typography variant="subtitle2">Distribution</Typography><Typography variant="body2" color="text.secondary">{asiOverview.distributionPolicy}</Typography></Box>}{asiOverview.marketingPolicy && <Box className="supplier-policy-copy"><Typography variant="subtitle2">Marketing</Typography><Typography variant="body2" color="text.secondary">{asiOverview.marketingPolicy}</Typography></Box>}</Box>}
              </Box>
            )}
            {asiOverview.story && <Box><Typography variant="h6" sx={{ mb: 0.5 }}>About Supplier</Typography><Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>{asiOverview.story}</Typography></Box>}
            {asiOverview.resources.length > 0 && <Box><Typography variant="h6" sx={{ mb: 0.5 }}>Resources</Typography><Box className="supplier-resource-list">{asiOverview.resources.map((resource) => <Button key={resource.url} component="a" href={resource.url} target="_blank" rel="noopener noreferrer" size="small" variant="outlined">{resource.name}</Button>)}</Box></Box>}
            {asiOverview.socialLinks.length > 0 && <Box><Typography variant="h6" sx={{ mb: 0.5 }}>Social / Links</Typography><SupplierSocialLinks links={asiOverview.socialLinks} /></Box>}
          </Box>
          ) : isInstanceCustomSupplier ? null : (
          <Box className="supplier-overview" sx={{ p: 2 }}>
            <Box className="supplier-source-heading">
              <Typography variant="h6" fontWeight={700}>Supplier Information</Typography>
              <Chip size="small" variant="outlined" label="Catalogue Supplier" />
              {isPreferred && <Chip size="small" color="success" label="Preferred" />}
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Catalogue-managed supplier details are read-only.
            </Typography>
            <Box className="supplier-profile-grid">
              <Box className="supplier-profile-card" sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>Contact Details</Typography>
                <Typography variant="body2">Name: {selectedSupplier?.Name || "—"}</Typography>
                <Typography variant="body2">Email: {selectedSupplier?.Email || "—"}</Typography>
                <Typography variant="body2">Phone: {selectedSupplier?.Phone?.Work || selectedSupplier?.phoneLabel || "—"}</Typography>
                <Typography variant="body2">Address: {formatAsiAddress(selectedSupplier?.Address) || "—"}</Typography>
              </Box>
              <Box className="supplier-profile-card" sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 2 }}>
                <Typography variant="subtitle1" fontWeight={700} gutterBottom>Catalogue</Typography>
                <Typography variant="body2">Source: {supplierReferences.map((ref) => ref.source).filter(Boolean).join(", ") || "External catalogue"}</Typography>
                <Typography variant="body2">Products: {selectedSupplier?.Products ?? "—"}</Typography>
                <Typography variant="body2">Services: {selectedSupplier?.ServiceCount ?? "—"}</Typography>
              </Box>
            </Box>
          </Box>
          )
        )}

        {popupTab === "shipping" && (
          <Box sx={{ p: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
              <Typography variant="h6">Supplier Shipping Accounts</Typography>
              <Button variant="contained" onClick={() => setShippingAccountModalOpen(true)}>
                Add Shipping Account
              </Button>
            </Box>
            {shippingAccountsLoading ? (
              <Typography>Loading shipping accounts...</Typography>
            ) : shippingAccounts.length === 0 ? (
              <Typography>No shipping accounts found for this supplier.</Typography>
            ) : (
              <Box sx={{ display: "grid", gap: 1 }}>
                {shippingAccounts.map((account) => (
                  <Box
                    key={account.id}
                    sx={{
                      border: "1px solid #eee",
                      borderRadius: 2,
                      p: 2,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle1">{account.accountName}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {account.courier} • {account.accountNumber} • {account.postalZipCode}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
            <ThirdPartyShippingAccount
              open={shippingAccountModalOpen}
              onClose={() => setShippingAccountModalOpen(false)}
              supplierId={selectedSupplier?.id}
              contextType="supplier"
              contextLabel={selectedSupplier?.Name}
              instanceUniqueId={instanceUniqueId}
              onCreated={loadShippingAccounts}
            />
          </Box>
        )}

        {popupTab === "contacts" && (
        <Box className="supplier-contacts" sx={{ display: "grid", gap: 2 }}>
            <Box
              className="supplier-contacts-header"
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
                flexWrap: "wrap",
              }}
            >
              <Box>
                <Typography variant="h6">Contacts</Typography>
                <Typography variant="body2" color="text.secondary">
                  Save supplier-specific contacts for this instance.
                </Typography>
              </Box>
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => setContactDialogOpen(true)}
              >
                Add Contact
              </Button>
            </Box>

            {isLiveAsiSupplier && (
              <Box className="supplier-contact-section" sx={{display:"grid",gap:1}}>
                <Typography variant="subtitle1" fontWeight={700}>ASI Contacts</Typography>
                {publicAsiContactsLoading ? <CircularProgress size={18}/> :
                  publicAsiContactError ? <Alert severity="warning">{publicAsiContactError}</Alert> :
                  publicAsiContacts.length===0 ? <Alert severity="info">No contacts were returned by ASI for this supplier.</Alert> :
                  <Box className="supplier-contact-grid">{publicAsiContacts.map((contact,index)=>(
                    <Box key={contact.email||index} className="supplier-contact-card" sx={{border:"1px solid",borderColor:"divider",borderRadius:"8px",p:1.5}}>
                      <Typography variant="subtitle2">{contact.name||"ASI contact"}</Typography>
                      {contact.title && <Typography variant="body2">{contact.title}</Typography>}
                      {contact.email && <Typography variant="body2"><strong>Email:</strong> {contact.email}</Typography>}
                      {contact.phone && <Typography variant="body2"><strong>Phone:</strong> {contact.phone}</Typography>}
                      <Typography variant="caption" color="text.secondary">ASI · Read only</Typography>
                    </Box>))}</Box>}
              </Box>
            )}
            {isLiveAsiSupplier && linkedSupplierContacts.length > 0 && (
              <Box className="supplier-contact-section" sx={{ display: "grid", gap: 1 }}>
                <Typography variant="subtitle1" fontWeight={700}>Linked Custom Supplier Contacts</Typography>
                {linkedSupplierContacts.map(group => (
                  <Box key={group.supplierId} sx={{ display: "grid", gap: 1 }}>
                    <Typography variant="body2" color="text.secondary">{group.supplierName}</Typography>
                    <Box className="supplier-contact-grid">
                      {(group.contacts || []).map((contact, index) => (
                        <Box key={`${group.supplierId}-${contact.email || index}`} className="supplier-contact-card" sx={{ border: "1px solid", borderColor: "divider", borderRadius: "8px", p: 1.5 }}>
                          <Typography variant="subtitle2">{[contact.firstName, contact.lastName].filter(Boolean).join(" ") || contact.name || "Supplier contact"}</Typography>
                          {contact.email && <Typography variant="body2"><strong>Email:</strong> {contact.email}</Typography>}
                          {contact.phone && <Typography variant="body2"><strong>Phone:</strong> {contact.phone}</Typography>}
                          {importedDateLabel(contact) && <Typography variant="caption" color="text.secondary">Added {importedDateLabel(contact)}</Typography>}
                          <Typography variant="caption" color="text.secondary">Your instance · linked custom supplier</Typography>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}
              </Box>
            )}
            {linkedSupplierError && isLiveAsiSupplier && <Alert severity="warning">{linkedSupplierError}</Alert>}
            {canViewAsiDiagnostic && <Typography variant="subtitle1" fontWeight={700}>Elite Core Contacts</Typography>}

            {supplierContacts.length > 0 ? (
              <Box className="supplier-contact-grid">
                {supplierContacts.map((contact, index) => {
                  const fullName = [contact.firstName, contact.lastName].filter(Boolean).join(" ").trim();
                  return (
                    <Box
                      key={`${contact.email || fullName || "contact"}-${index}`}
                      className="supplier-contact-card"
                      sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: "10px",
                        p: 1.25,
                        bgcolor: "background.paper",
                      }}
                    >
                      <Typography variant="subtitle1" fontWeight={700}>
                        {fullName || "Unnamed contact"}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {contact.title || contact.role || "No title"}
                      </Typography>
                      <Divider sx={{ my: 1.5 }} />
                      <Typography variant="body2">
                        <strong>Email:</strong> {contact.email || "N/A"}
                      </Typography>
                      <Typography variant="body2">
                        <strong>Phone:</strong> {contact.phone || "N/A"}
                      </Typography>
                      {importedDateLabel(contact) && <Typography variant="caption" color="text.secondary" sx={{ mt: 1 }}>Added {importedDateLabel(contact)}</Typography>}
                    </Box>
                  );
                })}
              </Box>
            ) : (
              <Box className="supplier-empty-contacts" role="status">
                <Typography variant="body2">No contacts available yet for this supplier.</Typography>
                <Tooltip title="No supplier contacts have been added yet." arrow>
                  <IconButton size="small" aria-label="Contact information">
                    <InfoOutlinedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </Box>
            )}
            {canManagePoEmail && (
            <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 2, display: 'grid', gap: 1.5 }}>
              <Typography variant="subtitle1" fontWeight={700}>Supplier Email Preferences</Typography>
              <Typography variant="body2" color="text.secondary">
                Default Purchase Order Recipient · applies only to your Elite Core instance.
                Does not change Supplier.Email or historical PO recipients.
              </Typography>
              {poPreferenceWarning && <Alert severity="warning">{poPreferenceWarning}</Alert>}
              {poPreferenceLoading ? <CircularProgress size={20} /> : (
                <>
                  <FormControl fullWidth size="small" disabled={!canManagePoEmail || poPreferenceSaving}>
                    <InputLabel id="supplier-po-email-mode-label">Default Purchase Order Recipient</InputLabel>
                    <Select labelId="supplier-po-email-mode-label" label="Default Purchase Order Recipient"
                      value={poEmailPreference.mode}
                      onChange={event => setPoEmailPreference(prev => ({ ...prev, mode: event.target.value, contactEmail: event.target.value === 'supplier' ? '' : prev.contactEmail }))}>
                      <MenuItem value="supplier">Use Supplier.Email (Default) — {supplierDetails?.Email || selectedSupplier?.Email || 'existing PO supplier email'}</MenuItem>
                      <MenuItem value="contact">Use a specific supplier contact</MenuItem>
                    </Select>
                  </FormControl>
                  {poEmailPreference.mode === 'contact' && (
                    <FormControl fullWidth size="small" disabled={!canManagePoEmail || poPreferenceSaving}>
                      <InputLabel id="supplier-po-preferred-contact-label">Preferred order contact</InputLabel>
                      <Select labelId="supplier-po-preferred-contact-label" label="Preferred order contact"
                        value={poEmailPreference.contactEmail}
                        onChange={event => setPoEmailPreference(prev => ({ ...prev, contactEmail: event.target.value }))}>
                        {poPreferenceContacts.map(contact => {
                          const email = String(contact.email).trim().toLowerCase();
                          const name = [contact.firstName, contact.lastName].filter(Boolean).join(' ') || contact.title || contact.department || 'Supplier contact';
                          return <MenuItem key={email} value={email}>{name} — {email}</MenuItem>;
                        })}
                      </Select>
                    </FormControl>
                  )}
                  <Typography variant="caption" color="text.secondary">
                    Default CC / BCC: no additional supplier contacts are added automatically.
                    Existing internal purchasing and notification recipients remain unchanged.
                  </Typography>
                  {isInstanceCustomSupplier && Array.isArray(supplierDetails?.Addresses || selectedSupplier?.Addresses) &&
              (supplierDetails?.Addresses || selectedSupplier?.Addresses).length > 0 && (
                <Box sx={{ display: 'grid', gap: 1 }}>
                  <Typography variant="h6">Addresses</Typography>
                  <Box className="supplier-address-grid">
                    {(supplierDetails?.Addresses || selectedSupplier?.Addresses).map((address, index) => {
                      const parts = [
                        address.streetAddress || address.Street1,
                        address.streetAddress2 || address.Street2,
                        address.city || address.City,
                        address.stateProvince || address.State,
                        address.postalZipCode || address.Zip,
                        address.country || address.Country,
                      ].filter(Boolean);
                      return (
                        <Box key={index} className="supplier-address-card" sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 1.5 }}>
                          <Typography variant="subtitle2">{address.addressName || address.AddressName || address.addressType || address.AddressType || 'Supplier address'}</Typography>
                          <Typography variant="body2" color="text.secondary">{parts.join(', ')}</Typography>
                          {importedDateLabel(address) && <Typography variant="caption" color="text.secondary">Added {importedDateLabel(address)}</Typography>}
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              )}
            {canManagePoEmail && (
                    <Button variant="outlined" sx={{ justifySelf: 'start' }} onClick={savePoEmailPreference}
                      disabled={poPreferenceSaving || (poEmailPreference.mode === 'contact' && !poEmailPreference.contactEmail)}>
                      {poPreferenceSaving ? 'Saving…' : 'Save PO Email Preference'}
                    </Button>
                  )}
                </>
              )}
            </Box>
            )}

        </Box>
        )}

        {popupTab === "association" && isInstanceCustomSupplier && isSupplierAdmin && (
        <Box sx={{maxWidth:780,p:2,display:'grid',gap:2.5,alignContent:'start'}}>
          <Box>
            <Typography variant="h6" fontWeight={700}>Supplier Association</Typography>
            <Typography variant="body2" color="text.secondary">
              Link this custom supplier to an ASI supplier. Both records remain separate, but the connection can be used for eligible purchase orders.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1} alignItems="center" sx={{width:"fit-content",maxWidth:"100%",px:1.5,py:0.8,border:"1px solid",borderColor:"divider",borderRadius:2}}>
            <Box sx={{width:9,height:9,minWidth:9,minHeight:9,flex:'0 0 9px',borderRadius:'50%',bgcolor:associatedSources.some(source=>source.provider==='asi')?'success.main':'error.main'}} />
            <Typography fontWeight={600} variant="body2">
              {associatedSources.some(source=>source.provider==='asi')?'Connected to ASI supplier':'Not connected'}
            </Typography>
          </Stack>
          {associatedSources.filter(source=>source.provider==='asi').map(source=>(
            <Box key={source.sourceSupplierId} sx={{display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:1.5,p:1.5,border:'1px solid',borderColor:'divider',borderRadius:2}}>
              <Typography variant="body2">Linked ASI supplier · Core #{source.sourceSupplierId}</Typography>
              <Button variant="outlined" color="warning" size="small" disabled={linkingAsi} onClick={()=>handleUnlinkAsi(source.sourceSupplierId)}>Unlink</Button>
            </Box>
          ))}
          <Box sx={{display:'flex',gap:1.5,alignItems:'center',flexWrap:'wrap',width:'fit-content'}}>
            <Typography variant="body2" color="text.secondary">Search market</Typography>
            <Stack direction="row" spacing={0.5} sx={{width:"fit-content",flex:"0 0 auto","& .MuiChip-root":{width:"auto",minWidth:46,height:27,flex:"0 0 auto"}}}>
              {['CANALL','GLOBAL'].map(value=><Chip key={value}
                label={value==='CANALL'?'CA':'ALL'} size="small" clickable
                color={asiAssociationMarket===value?'primary':'default'}
                variant={asiAssociationMarket===value?'filled':'outlined'}
                onClick={()=>{setAsiAssociationMarket(value);setSelectedAsiCandidate(null);setAsiLinkId('');}} />)}
            </Stack>
          </Box>
          <TextField size="small" sx={{maxWidth:650}} label="Find ASI supplier by name or ID"
            placeholder="Search CNIJ or 724" value={asiCandidateQuery}
            onChange={e=>{setAsiCandidateQuery(e.target.value);setSelectedAsiCandidate(null);setAsiLinkId('');setAsiSearchError('');}}
            disabled={linkingAsi}/>
          {asiCandidatesLoading && <Typography variant="caption">Searching the ASI supplier directory…</Typography>}
          {asiSearchError && <Alert severity="info">{asiSearchError}</Alert>}
          <Box sx={{display:'grid',gap:1,maxWidth:650}}>
            {asiCandidates.map(candidate=>(
              <Box key={candidate.id} onClick={()=>{setSelectedAsiCandidate(candidate);setAsiLinkId(candidate.id);}}
                sx={{cursor:'pointer',border:'1px solid',borderColor:selectedAsiCandidate?.id===candidate.id?'primary.main':'divider',
                  bgcolor:selectedAsiCandidate?.id===candidate.id?'action.selected':'background.paper',borderRadius:2,p:1.5,'&:hover':{bgcolor:'action.hover'}}}>
                <Typography variant="body2" fontWeight={600}>{candidate.name}</Typography>
                <Typography variant="caption" color="text.secondary">
                  Core #{candidate.id}{candidate.asiNumber?` · ASI ${candidate.asiNumber}`:''} · {candidate.market}
                </Typography>
              </Box>
            ))}
          </Box>
          {selectedAsiCandidate && <Alert severity="info" sx={{maxWidth:650}}>
            Selected: {selectedAsiCandidate.name} (Core #{selectedAsiCandidate.id}). Verify this is the same supplier before linking.
          </Alert>}
          <Box><Button variant="contained" disabled={linkingAsi || !selectedAsiCandidate}
            onClick={handleLinkAsi}>{linkingAsi?'Linking…':'Link to ASI Supplier'}</Button></Box>
        </Box>
      )}
      {popupTab === "quickbooks" && canManageQuickBooks && (
          <Box sx={{ p: 2, display: 'grid', gap: 1.5 }}>
            <Typography variant="h6">QuickBooks Vendor Mapping</Typography>
              <>
                <Typography variant="body2">
                  Status:{' '}
                  <strong>{supplierDetails?.qbo_ref_id || supplierDetails?.qboRefId ? 'Linked' : 'Not linked'}</strong>
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  QBO Vendor ID: {supplierDetails?.qbo_ref_id || supplierDetails?.qboRefId || '—'}
                </Typography>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button variant="contained" onClick={() => setQboDialogOpen(true)}>
                    Manage QuickBooks Link
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={handleDisconnectQbo}
                    disabled={disconnectingQbo || !(supplierDetails?.qbo_ref_id || supplierDetails?.qboRefId)}
                  >
                    {disconnectingQbo ? "Disconnecting..." : "Disconnect"}
                  </Button>
                </Box>
              </>
          </Box>
        )}

        {popupTab === "api-integration" && isSupplierAdmin && (
          <SupplierApiIntegrationTab
            instanceUniqueId={instanceUniqueId}
            supplierId={supplierCoreId}
            supplierName={supplierName}
            sourceSupplierId={selectedSupplier?.Id || selectedSupplier?.id}
          />
        )}

        {popupTab === "asi-diagnostic" && canViewAsiDiagnostic && (
          <Box sx={{ p: 2, display: "grid", gap: 2 }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2, flexWrap: "wrap" }}>
              <Box>
                <Typography variant="h6">ASI Live Diagnostic</Typography>
                <Typography variant="body2" color="text.secondary">
                  Displays the live supplier response returned by ASI. This tool is intended for integration diagnostics and does not modify supplier data.
                </Typography>
              </Box>
              <Button
                variant="outlined"
                startIcon={asiDiagnosticLoading ? <CircularProgress size={16} /> : <RefreshIcon />}
                onClick={loadAsiDiagnostic}
                disabled={asiDiagnosticLoading}
              >
                Refresh Response
              </Button>
            </Box>

            {asiDiagnosticError && <Alert severity="error">{asiDiagnosticError}</Alert>}

            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: 2,
              }}
            >
              <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, p: 2 }}>
                <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                  Supplier
                </Typography>
                <Typography variant="body2"><strong>Name:</strong> {selectedSupplier.Name || selectedSupplier.name || "N/A"}</Typography>
                <Typography variant="body2"><strong>ASI number:</strong> {selectedSupplier.AsiNumber || "N/A"}</Typography>
                <Typography variant="body2"><strong>ASI/Core supplier ID:</strong> {supplierCoreId || "N/A"}</Typography>
              </Box>

              <Box sx={{ border: "1px solid", borderColor: "divider", borderRadius: 1, p: 2 }}>
                <Typography variant="subtitle2" fontWeight={700} gutterBottom>
                  Request Status
                </Typography>
                <Typography variant="body2"><strong>HTTP status:</strong> {asiSupplierDetail?.status || (asiDiagnosticLoading ? "Loading..." : "N/A")}</Typography>
                <Typography variant="body2">
                  <strong>Retrieved:</strong>{" "}
                  {asiSupplierDetail?.retrievedAt ? new Date(asiSupplierDetail.retrievedAt).toLocaleString() : "N/A"}
                </Typography>
              </Box>
            </Box>

            <Box>
              <Typography variant="h6" sx={{ mb: 1 }}>Potential Contact Fields</Typography>
              {asiDiagnosticLoading && !asiSupplierDetail ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <CircularProgress size={18} />
                  <Typography variant="body2" color="text.secondary">Loading ASI response...</Typography>
                </Box>
              ) : Array.isArray(asiSupplierDetail?.contactMatches) && asiSupplierDetail.contactMatches.length > 0 ? (
                <Box sx={{ display: "grid", gap: 1, maxHeight: 260, overflow: "auto", pr: 0.5 }}>
                  {asiSupplierDetail.contactMatches.map((match, index) => (
                    <Box
                      key={`${match.path}-${index}`}
                      sx={{
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1,
                        p: 1.25,
                        bgcolor: "background.paper",
                      }}
                    >
                      <Typography variant="caption" sx={{ display: "block", fontFamily: "monospace", fontWeight: 700 }}>
                        {match.path}
                      </Typography>
                      <Box
                        component="pre"
                        sx={{
                          m: 0,
                          mt: 0.75,
                          whiteSpace: "pre-wrap",
                          overflowWrap: "anywhere",
                          fontSize: "0.78rem",
                          color: "text.secondary",
                          fontFamily: "monospace",
                        }}
                      >
                        {formatDiagnosticValue(match.value)}
                      </Box>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Alert severity="info">No obvious person/contact fields were detected in this ASI response.</Alert>
              )}
            </Box>

            <Box>
              <Typography variant="h6" sx={{ mb: 1 }}>ASI Response Fields</Typography>
              {Array.isArray(asiSupplierDetail?.topLevelKeys) && asiSupplierDetail.topLevelKeys.length > 0 ? (
                <Stack direction="row" spacing={0.75} flexWrap="wrap" useFlexGap>
                  {asiSupplierDetail.topLevelKeys.map(key => (
                    <Chip key={key} label={key} size="small" variant="outlined" />
                  ))}
                </Stack>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  No top-level fields loaded yet.
                </Typography>
              )}
            </Box>

            <Box>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, mb: 1 }}>
                <Typography variant="h6">Raw ASI Response</Typography>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCopyAsiDiagnosticJson}
                  disabled={!asiSupplierDetail?.response}
                >
                  Copy JSON
                </Button>
              </Box>
              <Box
                component="pre"
                sx={{
                  m: 0,
                  p: 2,
                  maxHeight: 420,
                  overflow: "auto",
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: 1,
                  bgcolor: theme.palette.mode === "dark" ? "grey.900" : "grey.50",
                  color: "text.primary",
                  fontFamily: "monospace",
                  fontSize: "0.78rem",
                  lineHeight: 1.5,
                  whiteSpace: "pre",
                }}
              >
                {asiSupplierDetail?.response ? JSON.stringify(asiSupplierDetail.response, null, 2) : "{}"}
              </Box>
            </Box>
          </Box>
        )}

        <Dialog open={mergeDialogOpen} onClose={() => !mergeLoading && setMergeDialogOpen(false)} fullWidth maxWidth="md">
          <DialogTitle>Combine duplicate suppliers</DialogTitle>
          <DialogContent dividers sx={{ display: "grid", gap: 2 }}>
            <Alert severity="info">Choose which supplier record to keep. We'll combine missing contact and address details without replacing existing information. The duplicate will be hidden from future searches in this company. Old products, orders, purchase orders and invoices will still work.</Alert>
            <Typography variant="body2"><strong>Duplicate supplier to remove from future searches:</strong> {supplierDetails?.Name || selectedSupplier?.Name} (#{supplierCoreId})</Typography>
            <Autocomplete fullWidth options={mergeSupplierOptions}
              loading={mergeSupplierSearching}
              filterOptions={options => options}
              noOptionsText={mergeSupplierSearching ? "Searching your suppliers..." : mergeSupplierQuery.trim() ? "No matching active custom suppliers found" : "No other active custom suppliers found"}
              getOptionLabel={option => typeof option === "string" ? option : option.name + " (#" + option.id + ")"}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              value={mergeSupplierOptions.find(option => option.id === mergeSurvivorId) || (mergeSurvivorId && mergePreview ? { id: mergeSurvivorId, name: mergePreview.survivor.name } : null)}
              inputValue={mergeSupplierQuery}
              onInputChange={(_, value, reason) => { if (reason === "input" || reason === "clear") setMergeSupplierQuery(value); }}
              onChange={(_, option) => { setMergeSurvivorId(option?.id || ""); setMergePreview(null); resetMergePreview(); }}
              renderInput={params => <TextField {...params} label="Which supplier do you want to keep?" placeholder="Type a supplier name or ID" size="small"
                helperText="Start typing to search your custom suppliers. ASI suppliers and archived records are not available."
                InputProps={{ ...params.InputProps, endAdornment: <>{mergeSupplierSearching && <CircularProgress color="inherit" size={18} />}{params.InputProps.endAdornment}</> }} />} />
            {!mergePreview && <Button variant="outlined" disabled={mergeLoading || !mergeSurvivorId}
              onClick={() => requestMergePreview([], false)}>Review what will change</Button>}
            {mergePreview && <>
              <Typography variant="subtitle1" fontWeight={700}>Supplier to keep: {mergePreview.survivor.name} (#{mergePreview.survivor.id})</Typography>
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                <Chip label={mergePreview.archiveCount + " original products hidden from future searches"} size="small" />
                <Chip label={mergePreview.copyCount + " new product copies to create"} size="small" color="primary" />
              </Stack>
              <Typography variant="body2">Preferred — source: {mergePreview.sourcePreferred ? "Yes" : "No"} · destination: {mergePreview.survivorPreferred ? "Yes" : "No"}</Typography>
              <Typography variant="body2">PO email — source: {mergePreview.sourcePoEmailPreference?.contactEmail || "Supplier default"} · destination: {mergePreview.survivorPoEmailPreference?.contactEmail || "Supplier default"}</Typography>
              {(mergePreview.conflicts || []).map((message, i) => <Alert key={i} severity="warning">{message}</Alert>)}
              <FormControlLabel control={<Checkbox checked={mergeCopySelected} onChange={event => {
                const checked = event.target.checked; setMergeCopySelected(checked);
                setMergeSelectedIds(checked ? mergePreview.products.filter(p => !p.inventoryBlocked).map(p => p.id) : []);
                resetMergePreview();
              }} />} label="Copy selected products to the supplier you keep" />
              {mergeCopySelected && <>
                <TextField label="Filter source products" size="small" value={mergeSearch} onChange={event => setMergeSearch(event.target.value)} />
                <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
                  <Typography variant="body2">{mergeSelectedIds.length} of {mergePreview.products.length} products selected</Typography>
                  <Button size="small" onClick={() => {
                    const visible = mergePreview.products.filter(p => !p.inventoryBlocked && (p.name + " " + p.sku).toLowerCase().includes(mergeSearch.toLowerCase())).map(p => p.id);
                    setMergeSelectedIds(old => [...new Set([...old, ...visible])]);
                    resetMergePreview();
                  }}>Select filtered</Button>
                  <Button size="small" onClick={() => {
                    const visible = new Set(mergePreview.products.filter(p => (p.name + " " + p.sku).toLowerCase().includes(mergeSearch.toLowerCase())).map(p => p.id));
                    setMergeSelectedIds(old => old.filter(id => !visible.has(id)));
                    resetMergePreview();
                  }}>Clear filtered</Button>
                  <Button size="small" onClick={() => { setMergeSelectedIds([]); resetMergePreview(); }}>Clear all</Button>
                </Stack>
                <Box sx={{ maxHeight: 300, overflowY: "auto", border: "1px solid", borderColor: "divider", borderRadius: 1 }}>
                  {mergePreview.products.filter(p => (p.name + " " + p.sku).toLowerCase().includes(mergeSearch.toLowerCase())).map(p => (
                    <Box key={p.id} sx={{ display: "flex", alignItems: "center", gap: 1, p: 1, borderBottom: "1px solid", borderColor: "divider" }}>
                      <Checkbox size="small" checked={mergeSelectedIds.includes(p.id)} disabled={p.inventoryBlocked}
                        onChange={e => { setMergeSelectedIds(old => e.target.checked ? [...old, p.id] : old.filter(id => id !== p.id)); resetMergePreview(); }} />
                      {p.image && <Box component="img" src={p.image} alt="" sx={{ width: 42, height: 42, objectFit: "contain" }} />}
                      <Box flex={1}><Typography variant="body2" fontWeight={600}>{p.name}</Typography>
                        <Typography variant="caption" color="text.secondary">{p.sku || "No SKU"} · #{p.id}</Typography></Box>
                      {p.inventoryBlocked && <Chip size="small" color="warning" label="Inventory / external sync" />}
                    </Box>
                  ))}
                </Box>
              </>}
              {mergeDirty && <Alert severity="warning">Your selection changed. Update the review before combining suppliers.</Alert>}
              <Button variant="outlined" disabled={mergeLoading} onClick={() => requestMergePreview(mergeSelectedIds, mergeCopySelected)}>Update review</Button>
              <FormControlLabel control={<Checkbox checked={mergeAcknowledged} onChange={e => setMergeAcknowledged(e.target.checked)} />}
                label="I checked the preferred supplier settings and purchase order email recipients." />
              <FormControlLabel control={<Checkbox checked={mergeConfirmed} onChange={e => setMergeConfirmed(e.target.checked)} />}
                label="I understand the duplicate supplier and its original products will be hidden from future searches, but past orders will remain unchanged." />
            </>}
            {mergeWarning && <Alert severity="error">{mergeWarning}</Alert>}
          </DialogContent>
          <DialogActions>
            <Button disabled={mergeLoading} onClick={() => setMergeDialogOpen(false)}>Cancel</Button>
            {mergePreview && <Button color="warning" variant="contained" disabled={mergeLoading || mergeDirty || !mergeAcknowledged || !mergeConfirmed}
              onClick={confirmMerge}>{mergeLoading ? "Processing…" : "Confirm merge"}</Button>}
          </DialogActions>
        </Dialog>

        <Dialog open={contactDialogOpen} onClose={() => !contactSaving && setContactDialogOpen(false)} fullWidth maxWidth="sm">
          <DialogTitle>Add Supplier Contact</DialogTitle>
          <Formik
            initialValues={{
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              title: "",
            }}
            validationSchema={Yup.object({
              firstName: Yup.string().trim(),
              lastName: Yup.string().trim(),
              email: Yup.string().trim().email("Enter a valid email"),
              phone: Yup.string().trim(),
              title: Yup.string().trim(),
            }).test(
              "contact-required",
              "Add at least a first name, last name, or email.",
              (value) => Boolean(value?.firstName || value?.lastName || value?.email)
            )}
            onSubmit={handleSaveContact}
          >
            {({ isSubmitting }) => (
              <Form>
                <DialogContent dividers>
                  <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" } }}>
                    <Field as={TextField} name="firstName" label="First Name" fullWidth />
                    <Field as={TextField} name="lastName" label="Last Name" fullWidth />
                    <Field as={TextField} name="email" label="Email" type="email" fullWidth />
                    <Field as={TextField} name="phone" label="Phone" fullWidth />
                    <Box sx={{ gridColumn: { xs: "1 / -1", sm: "1 / -1" } }}>
                      <Field as={TextField} name="title" label="Title / Role" fullWidth />
                    </Box>
                  </Box>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setContactDialogOpen(false)} disabled={contactSaving || isSubmitting}>
                    Cancel
                  </Button>
                  <Button type="submit" variant="contained" disabled={contactSaving || isSubmitting}>
                    {contactSaving ? "Saving..." : "Save Contact"}
                  </Button>
                </DialogActions>
              </Form>
            )}
          </Formik>
        </Dialog>

        <ProductPopup
          isOpen={productPopupOpen}
          onRequestClose={closeProductDetails}
          productId={popupProductId}
          instanceUniqueId={instanceUniqueId}
          lookupType={productLookupType}
        />


        
          <div className="popup-button-group supplier-sticky-action-bar">
            <button
              type="button"
              className="popup-button close"
              onClick={handleCloseSupplierPopup}
            >
              Close
            </button>

           {isInstanceCustomSupplier && isSupplierAdmin && !isArchivedSupplier && (
             <button type="button" className="popup-button" onClick={() => {
               setMergeSurvivorId("");
               setMergeSupplierQuery("");
               setMergeSupplierOptions([]);
               setMergeWarning("");
               setMergePreview(null);
               setMergeSelectedIds([]);
               setMergeCopySelected(false);
               resetMergePreview();
               setMergeDialogOpen(true);
             }}>Merge</button>
           )}

           {isInstanceCustomSupplier && (isSupplierAdmin || isArchivedSupplier) && (
             <button
               type="button"
               className="popup-button"
               onClick={isSupplierAdmin ? handleArchiveSupplier : undefined}
               disabled={!isSupplierAdmin || isArchivedSupplier || archivingSupplier}
             >
               {isArchivedSupplier ? "Archived" : archivingSupplier ? "Archiving..." : "Archive supplier"}
             </button>
           )}

           {canManagePreferred && !isArchivedSupplier && (
            <>
             <Tooltip title="This feature is only available to administrators and is currently disabled.">
               <span>
                 <button
                   type="button"
                   className="popup-button import"
                   disabled
                 >
                   Import Products
                 </button>
               </span>
             </Tooltip>
            {progress?.done && (
              <span className="import-count">
                ✅ Import Completed
              </span>
            )}

              <button
                type="button"
                onClick={handlePreferredAction}
                className="popup-button"
                disabled={preferredSaving}
                title={isPreferred ? "Remove preferred designation" : "Add to preferred suppliers"}
              >
                {preferredSaving ? "Saving..." : isPreferred ? "✓ Preferred Supplier" : "Set as preferred supplier"}
              </button>
            </>
           )}
      </div> 

      {canManagePreferred && progress && (
        <Box mt={2}>
          <p>Importing {progress.processed} / {progress.total} products</p>
          <p>Page {progress.currentPage} / {progress.totalPages}</p>
          <p>Last processed: {progress.lastItem}</p>

          <LinearProgress
            variant="determinate"
            value={(progress.processed / progress.total) * 100}
          />
        </Box>
      )}




        </div>
          </div>

          {canManageQuickBooks && <QboVendorLinkDialog
            open={qboDialogOpen}
            onClose={() => setQboDialogOpen(false)}
            instanceUniqueId={instanceUniqueId}
            supplierId={supplierDetails?.id || supplierDetails?.Id || null}
            supplierName={supplierDetails?.Name || supplierDetails?.name || ''}
            onLinked={(payload) => {
              if (payload?.qboId) {
                setSupplierDetails((prev) => ({
                  ...prev,
                  qbo_ref_id: payload.qboId,
                  qboRefId: payload.qboId,
                  qbo_link_status: 'linked',
                }));
              }
              setQboDialogOpen(false);
            }}
          />}
      </div>
    </div>
  );
};

export default InstanceSuppliers;
